export const glPtBr = {
  common: {
    loading: 'carregando...',
    select: 'Selecione',
    none: 'Nenhum',
    save: 'Salvar',
    cancel: 'Cancelar',
    create: 'Criar',
    saving: 'Salvando...',
    now: 'Agora',
    clear: 'Limpar',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    close: 'Fechar',
    entityLabel: 'Entidade',
    entityPlaceholder: 'Selecione a entidade',
    bookLabel: 'Livro',
    bookPlaceholder: 'Selecione o livro',
    periodLabel: 'Período',
    periodPlaceholder: 'Selecione o período',
    accountLabel: 'Conta contábil',
    accountPlaceholder: 'Selecione a conta',
    staleAccountOtherCoaVersion:
      'Esta conta não está disponível para este campo. Revise o mapeamento ou selecione outra conta.',
    glAccountSplit: {
      distributionLabel: 'Distribuir entre contas:',
      addItemLabel: '+ Adicionar conta',
      itemLabel: 'conta',
      itemsLabel: 'contas',
    },
  },
  errors: {
    loadCoaVersions: 'Erro ao carregar versões do plano de contas.',
    publishVersion: 'Erro ao publicar versão do plano de contas.',
    loadAccounts: 'Erro ao carregar contas contábeis.',
    loadBooks: 'Erro ao carregar livros.',
    loadPeriods: 'Erro ao carregar períodos.',
    periodNotFoundForEntity: 'Período não encontrado para a entidade selecionada.',
    loadRollupData: 'Erro ao carregar dados de rollup/crosswalk.',
    saveRollups: 'Erro ao salvar rollups.',
    saveRollupGroup: 'Erro ao salvar grupo de rollup.',
    inactivateAccount: 'Erro ao inativar conta.',
    createAccount: 'Erro ao criar conta contábil.',
    updateAccount: 'Erro ao atualizar conta contábil.',
    deleteMappedAccount:
      'Esta conta está vinculada a uma configuração contábil. Remapeie a conta de sistema ou do cadastro antes de excluí-la.',
  },
  scopedAccountSelector: {
    chart: 'Plano de contas resolvido:',
    empty: 'Este plano de contas não possui contas disponíveis.',
    scopeUnavailable: 'Não foi possível resolver o plano de contas.',
    selectEntityFirst: 'Selecione uma entidade primeiro para escolher uma conta contábil.',
  },
  access: {
    loadError: 'Não foi possível carregar as permissões da conta.',
    updateError: 'Não foi possível atualizar a política de acesso.',
    saveError: 'Não foi possível salvar as alterações.',
    protected: 'Dados protegidos.',
    defaultRestored: 'Acesso padrão restaurado.',
    changesSaved: 'Alterações salvas.',
    manage: 'Gerenciar acesso',
    protect: 'Proteger dados da conta',
    title: 'Controle de acesso',
    restrictionLabel: 'Restringir acesso',
    restrictionDescription:
      'Somente pessoas e grupos autorizados poderão consultar esta conta e seus saldos.',
    inheritedDescription:
      'Pessoas com permissão para consultar o plano de contas podem ver esta conta.',
    restricted: 'Acesso restrito',
    useDefault: 'Usar acesso padrão',
    addPeople: 'Adicionar pessoas',
    selectPeople: 'Selecione pessoas',
    searchPeople: 'Buscar pessoa',
    noPeople: 'Nenhuma pessoa disponível',
    addAnotherPerson: 'Adicionar outra pessoa',
    addGroup: 'Adicionar grupo',
    selectGroup: 'Selecione um grupo',
    peopleWithAccess: 'Pessoas com acesso',
    groupsWithAccess: 'Grupos com acesso',
    group: 'Grupo',
    undo: 'Desfazer {{name}}',
    undoRemoval: 'Desfazer remoção de {{name}}',
    remove: 'Remover {{name}}',
    confirm: 'Confirmar',
    protectTitle: 'Proteger dados desta conta?',
    protectDescription:
      'Somente pessoas e grupos autorizados poderão consultar esta conta e seus saldos.',
    defaultTitle: 'Usar acesso padrão?',
    defaultDescription_one:
      'A conta voltará a seguir as permissões comuns do plano de contas, e a autorização atual será removida. Se você restringir a conta depois, a lista começa vazia.',
    defaultDescription_other:
      'A conta voltará a seguir as permissões comuns do plano de contas, e as {{count}} autorizações atuais serão removidas. Se você restringir a conta depois, a lista começa vazia.',
    noRole: 'sem função',
    viaGroups: 'Via grupo: {{groups}}',
    saveTitle: 'Salvar alterações de acesso?',
    saveDescription_one: '{{count}} alteração de acesso será aplicada.',
    saveDescription_other: '{{count}} alterações de acesso serão aplicadas.',
    discardChangesTitle: 'Descartar alterações?',
    discardChangesDescription: 'As permissões que ainda não foram salvas serão perdidas.',
    discardChangesConfirm: 'Descartar alterações',
  },
  pages: {
    coa: {
      title: 'Plano de contas contábil',
      description: 'Visualize e versione o plano de contas com rollups e crosswalks.',
      selectEntity: 'Selecione a entidade',
      emptyState: {
        selectEntityTitle: 'Selecione uma entidade',
        selectEntityDescription:
          'Selecione uma entidade para ver o plano de contas. Tenants com mais de uma entidade podem ter versões ativas diferentes por entidade.',
      },
      loadingVersions: 'Carregando versões...',
      selectVersion: 'Selecione a versão',
      importTargetVersion: 'Versão de destino',
      importTargetVersionHelp:
        'Só é possível importar para versões em rascunho ou aplicada. Versões publicadas/agendadas não aceitam importação.',
      searchPlaceholder: 'Pesquisar contas...',
      presets: {
        hideUnusedAccounts: 'Ocultar contas sem lançamento',
        hiddenUnusedNotice: 'Contas sem lançamentos estão ocultas. Para mostrá-las,',
        hiddenUnusedNoticeAction: 'clique aqui',
        foldedChildren_one: '+ {{formattedCount}} conta',
        foldedChildren_other: '+ {{formattedCount}} contas',
        viewError: 'Não foi possível carregar esta visualização.',
        retry: 'Tentar novamente',
        viewDetailed: 'Ver detalhado',
      },
      navigateToRollupDesigner: 'Rollup / Crosswalk',
      createAccount: 'Criar conta',
      createAccountSheet: {
        title: 'Nova conta',
        description: 'Preencha os dados básicos da conta.',
        fields: {
          parentAccount: 'Conta pai',
          parentAccountPlaceholder: 'Selecione a conta pai',
          code: 'Código',
          name: 'Nome',
          namePlaceholder: 'Nova conta',
          type: 'Tipo',
          naturalBalance: 'Saldo natural',
          isPostable: 'Conta lançável',
          isContra: 'Conta redutora (contra conta)',
          isContraHelp:
            'Marque quando o saldo reduz a conta principal, como depreciação ou amortização acumulada.',
          contraOfAccount: 'Conta principal reduzida',
          contraOfAccountPlaceholder: 'Selecione a conta principal',
          isConsolidationElimination: 'Conta de eliminação na consolidação',
          isConsolidationEliminationHelp:
            'Use somente em uma conta dedicada a saldos recíprocos entre matriz e filial.',
        },
        validation: {
          codeAlreadyExists: 'O código {{code}} já existe nesta versão do plano de contas.',
          parentRequired: 'Selecione a conta pai antes de criar a conta.',
          contraOfRequired: 'Selecione a conta principal que esta conta reduz.',
        },
        actions: {
          create: 'Criar',
        },
        accountTypes: {
          asset: 'Ativo',
          liability: 'Passivo',
          equity: 'Patrimônio líquido',
          revenue: 'Receita',
          cogs: 'Custo (CMV/CPV/CSP)',
          expense: 'Despesa',
          otherIncome: 'Outras receitas',
          otherExpense: 'Outras despesas',
          contraAsset: 'Contra-ativo',
          contraLiability: 'Contra-passivo',
          contraEquity: 'Contra-patrimônio',
        },
        naturalBalances: {
          debit: 'Devedora',
          credit: 'Credora',
        },
      },
      expandAll: 'Expandir tudo',
      collapseAll: 'Recolher tudo',
      globalSettings: {
        button: 'Configurações globais',
        title: 'Configurações globais',
        description:
          'Defina as contas raiz para fornecedores (AP), adiantamentos, contas bancárias, cartões de crédito e clientes (AR).',
        accountSelectorPlaceholder: 'Buscar conta...',
        vendorRoot: 'Conta raiz para fornecedores (AP)',
        supplierAdvanceRoot: 'Conta raiz para adiantamentos a fornecedores (AP)',
        bankRoot: 'Conta raiz para contas bancárias',
        creditCardRoot: 'Conta raiz para cartões de crédito',
        arCustomerRoot: 'Conta raiz para clientes (AR)',
        helpers: {
          assetOnly: 'Apenas contas do tipo Ativo desta versão.',
          liabilityOnly: 'Apenas contas do tipo Passivo desta versão.',
        },
        warnings: {
          assetOnly: 'A conta selecionada não é do tipo Ativo nesta versão; selecione outra conta.',
          liabilityOnly:
            'A conta selecionada não é do tipo Passivo nesta versão; selecione outra conta.',
          currentPointsOtherVersion:
            'A configuração atual aponta para outra versão; selecione uma conta desta versão.',
        },
        actions: {
          saving: 'Salvando...',
        },
        toasts: {
          loadError: 'Erro ao carregar configurações globais',
          saveError: 'Erro ao salvar configurações globais',
          saveSuccess: 'Configurações salvas com sucesso',
        },
      },
      deleteDraft: 'Excluir rascunho',
      startDate: {
        action: 'Data de início',
        title: 'Data de início do plano de contas',
        label: 'Começa em',
        description_one:
          'A {{count}} conta deste rascunho passa a começar nesta data. Documentos com competência a partir desta data poderão usar esta conta.',
        description_other:
          'As {{count}} contas deste rascunho passam a começar nesta data. Documentos com competência a partir desta data poderão usar estas contas.',
        confirm: 'Salvar data de início',
        hint: 'Início: {{date}}',
        hintNone: 'Sem data de início',
        errors: {
          COA_VERSION_NOT_DRAFT:
            'Só é possível mudar a data de início de uma versão em rascunho do plano de contas.',
          COA_VERSION_START_DATE_INVALID:
            'A data de início do plano de contas não é uma data válida.',
          generic: 'Erro ao salvar a data de início.',
        },
      },
      deleteDraftConfirmTitle: 'Excluir rascunho?',
      deleteDraftConfirmDescription:
        'A versão {{version}} será excluída permanentemente. Essa ação não pode ser desfeita.',
      deleteAccountConfirm: 'Excluir conta',
      deleteAccountConfirmTitle: 'Excluir conta?',
      deleteAccountConfirmDescription:
        'A conta {{account}} será excluída permanentemente. Essa ação não pode ser desfeita.',
      publishVersion: 'Publicar versão',
      manageActivation: 'Ativar / Agendar',
      activation: {
        title: 'Ativação da versão',
        book: 'Livro',
        selectBook: 'Selecione o livro',
        loadingPreview: 'Analisando impacto…',
        canActivate: 'Pode ativar',
        cannotActivate: 'Não pode ativar',
        periodsToRestamp: 'Períodos abertos a recarimbar',
        periodsKept: 'Períodos com lançamentos (mantidos)',
        periodsClosed: 'Períodos fechados',
        suggestedGoLive: 'Go-live sugerido',
        blockingTitle: 'Bloqueios',
        warningsTitle: 'Avisos',
        goLiveDate: 'Data de go-live (agendar)',
        goLiveDateCalendar:
          'A data é aplicada à meia-noite no calendário contábil do livro selecionado.',
        activateNow: 'Ativar agora',
        schedule: 'Agendar',
        cancelSchedule: 'Cancelar agendamento',
        activateError: 'Erro ao ativar a versão do plano de contas.',
        issues: {
          OPEN_PERIODS_WITH_POSTINGS:
            '{{count}} período(s) aberto(s) com lançamentos permanecerão na versão atual (histórico imutável).',
          CROSSWALK_INCOMPLETE:
            '{{count}} conta(s) da versão ativa não estão mapeadas para a versão alvo.',
          ALREADY_ACTIVE: 'Esta versão já é a versão ativa para esta entidade/livro.',
          VERSION_NOT_PUBLISHED: 'A versão alvo precisa estar publicada para ser ativada.',
          COA_ACTIVATION_IMPACT_STALE:
            'A análise de impacto ficou desatualizada durante a ativação (o plano vigente, o mapeamento entre planos ou os períodos mudaram). Nada foi alterado: atualize a prévia de ativação e ative novamente.',
        },
      },
      deprecateVersion: 'Descontinuar versão',
      deprecateError: 'Erro ao descontinuar a versão do plano de contas.',
      deprecation: {
        issues: {
          COA_VERSION_DEPRECATION_BLOCKED:
            'Não é possível descontinuar: ainda em uso por {{count}} escopo(s) (entidade/livro) ativo(s) ou agendado(s). Cancele o agendamento ou migre o escopo para outra versão antes de descontinuar.',
        },
      },
      createVersion: 'Nova versão',
      revenueClasses: 'Classes de receita',
      revenueClassesNoEntity: 'Nenhuma entidade brasileira usa esta versão do plano.',
      export: 'Exportar',
      exportCsv: 'CSV',
      exportPdf: 'PDF',
      exportXlsx: 'Excel',
      createVersionTitle: 'Nova versão do plano de contas',
      createVersionDescription:
        'Crie uma versão em rascunho, opcionalmente copiando de uma versão existente.',
      crosswalkWithParent: 'Crosswalk com versão pai:',
      mappings: '{{count}} mapeamento',
      mappings_plural: '{{count}} mapeamentos',
      columns: {
        account: 'Conta',
        code: 'Código',
        type: 'Tipo',
        naturalBalance: 'Saldo natural',
        netBalance: 'Saldo líquido',
        rollup: 'Rollup',
        isPostable: 'Lançável',
        status: 'Status',
        effectiveRange: 'Vigência',
        actions: 'Ações',
      },
      boolean: {
        yes: 'Sim',
        no: 'Não',
      },
      statusLabels: {
        active: 'Ativo',
        inactive: 'Inativo',
      },
      versionStatusLabels: {
        inUse: 'Em uso',
        draft: 'Rascunho',
        published: 'Publicado',
        scheduled: 'Agendado',
        deprecated: 'Arquivada',
      },
      form: {
        versionNumberLabel: 'Versão',
        versionNumberPlaceholder: 'Ex: 1.1, 2025-01',
        nameLabel: 'Nome',
        namePlaceholder: 'Nome descritivo da versão',
        descriptionLabel: 'Descrição (opcional)',
        descriptionPlaceholder: 'Resumo do objetivo desta versão',
        parentVersionLabel: 'Versão base (opcional)',
        parentVersionPlaceholder: 'Selecione uma versão para copiar as contas',
        parentVersionNone: 'Nenhuma (começar do zero)',
        parentVersionHelp:
          'Se você escolher uma versão base, as contas serão copiadas automaticamente.',
        notesLabel: 'Notas internas (opcional)',
        notesPlaceholder: 'Contexto para histórico ou auditoria',
        startDateLabel: 'Data de início (opcional)',
        startDateHelp:
          'As contas desta versão começam nesta data. Sem data, elas começam no dia em que forem criadas ou importadas.',
      },
      createVersionSubmit: 'Criar versão',
      tooltips: {
        togglePostableOn: 'Ativar lançamentos',
        togglePostableOff: 'Desativar lançamentos',
      },
    },
    rollupDesigner: {
      saveRollups: 'Salvar rollups',
      saving: 'Salvando...',
      groupsTitle: 'Grupos de Rollup',
      accountMappingsTitle: 'Mapeamento de contas → rollup',
      balanceSheet: 'Balanço Patrimonial',
      incomeStatement: 'Demonstração de Resultado',
      subtotal: 'Subtotal',
      newGroupButton: 'Novo grupo',
      groupForm: {
        newTitle: 'Novo grupo de rollup',
        editTitle: 'Editar grupo de rollup',
        codeLabel: 'Código',
        nameLabel: 'Nome',
        categoryLabel: 'Categoria',
        displayOrderLabel: 'Ordem',
        isSubtotalLabel: 'Subtotal',
        saveButton: 'Salvar',
        cancelButton: 'Cancelar',
      },
    },
    rollups: {
      title: 'Agrupamentos',
      back: 'Voltar',
      emptyState: {
        selectEntityTitle: 'Selecione uma entidade',
        selectEntityDescription:
          'Selecione uma entidade para ver as contas contábeis disponíveis para agrupamentos.',
      },
      listTitle: 'Agrupamentos FP&A',
      newRollup: 'Novo agrupamento',
      standardBadge: 'Padrão',
      create: 'Criar',
      accounts: 'contas',
      noRollupSelected: 'Nenhum agrupamento selecionado',
      noRollupSelectedDesc: 'Selecione um agrupamento na lista à esquerda ou crie um novo.',
      noRollups: 'Nenhum agrupamento criado ainda.',
      noRollupsHint: 'Clique em + para criar um novo.',
      rename: 'Renomear',
      restoreDefault: 'Restaurar padrão',
      restoreDefaultConfirm:
        'Restaurar "{{name}}" para a definição padrão? Contas, filtros e fórmula personalizados serão substituídos.',
      restoredToDefault: 'Agrupamento restaurado para o padrão.',
      deleteRollup: 'Excluir agrupamento',
      deleteRollupConfirm: 'Excluir "{{name}}"? Esta ação arquiva o agrupamento.',
      addAccount: 'Adicionar conta',
      removeAccount: 'Remover conta',
      groupNameLabel: 'Nome',
      groupNamePlaceholder: 'Ex: Receita Bruta, Lucro Líquido...',
      groupTypeLabel: 'Tipo',
      groupTypeSum: 'Σ Soma',
      groupTypeFormula: 'ƒ Calculado',
      includedAccountsLabel: 'Contas incluídas',
      accountTypesLabel: 'Seleção por tipo de conta',
      advancedLabel: 'Avançado',
      formatLabel: 'Formato',
      parentLabel: 'Agrupamento pai',
      readOnlyViaApi: 'Somente leitura no editor — edite via MCP/API.',
      formulaLabel: 'Fórmula',
      moreAccounts: '+{{count}} mais',
      formulaReadOnly:
        'Esta fórmula usa métricas ou período anterior e é somente leitura aqui — edite via MCP/API.',
      addToFormula: 'Adicionar à fórmula',
      parentheses: 'Parênteses',
      rollupRefs: 'Agrupamentos',
      numberToken: 'Número',
      removeToken: 'Remover item da fórmula',
      filtersWhere: 'Filtros (WHERE)',
      logicAnd: 'Lógica: AND',
      addFilter: 'Adicionar filtro',
      removeFilter: 'Remover filtro',
      filterDialogTitle: 'Adicionar filtro',
      filterDimensionLabel: 'Dimensão',
      filterDimensionPlaceholder: 'Selecione uma dimensão',
      filterOperatorLabel: 'Operador',
      filterValuesLabel: 'Valor(es)',
      add: 'Adicionar',
      dimensions: {
        entity: 'Entidade',
        managerialAccount: 'Conta gerencial',
        costCenter: 'Centro de custo',
        department: 'Departamento',
        vendor: 'Fornecedor',
      },
      errors: {
        nameTaken: 'Já existe um agrupamento com esse nome.',
        inUse: 'Este agrupamento é usado por templates ou fórmulas e não pode ser excluído.',
        segmentFilterContabil:
          'Filtros de segmento só são suportados em agrupamentos de fonte Gerencial.',
        segmentTextFilterUnsupported:
          'Filtros de rollup aceitam apenas valores predefinidos; valores de texto livre ainda não podem ser filtrados.',
        segmentFilterValueConflict:
          'Use valores predefinidos ou texto livre no filtro de segmento, não os dois juntos.',
        segmentTextValueNotAllowed:
          'Este campo não aceita texto livre. Escolha um valor predefinido do catálogo.',
        segmentPredefinedValueNotAllowed:
          'Este campo não possui catálogo de valores. Remova os valores predefinidos deste filtro.',
        segmentTextValueTooLong: 'O texto livre do filtro deve ter no máximo 200 caracteres.',
        accountSourceMismatch: 'A conta selecionada não corresponde à fonte do agrupamento.',
        accountNotFound: 'Conta não encontrada.',
        accountDuplicate: 'Conta duplicada no agrupamento.',
        accountRefShape: 'Referência de conta inválida.',
        formulaRequired: 'Agrupamentos calculados exigem uma fórmula.',
        formulaInvalid: 'Fórmula inválida.',
        formulaCycle: 'A fórmula cria uma referência circular entre agrupamentos.',
        calculatedNoSelection:
          'Agrupamentos calculados não podem ter contas ou filtros selecionados.',
        aggregationNoFormula: 'Agrupamentos de soma não podem ter fórmula.',
        rollupRefNotFound: 'A fórmula referencia um agrupamento inexistente.',
        parentCycle: 'A hierarquia de agrupamentos não pode conter ciclos.',
        definitionReported:
          'Este agrupamento alimenta um relatório já congelado — a alteração exige consentimento de republicação via API.',
        notStandard: 'Apenas agrupamentos padrão podem ser restaurados.',
        standardDefinitionMissing: 'Definição padrão não encontrada para este agrupamento.',
      },
    },
    fxEvidence: {
      title: 'Evidência da taxa de câmbio',
      contextLabel: 'Contexto',
      pairLabel: 'Par de moedas',
      rateLabel: 'Taxa exata',
      requestedDateLabel: 'Data contábil solicitada',
      quoteDateLabel: 'Data efetiva da cotação',
      sourceLabel: 'Fonte',
      providerLabel: 'Provedor',
      quoteIdentifierLabel: 'Identificador da cotação',
      manualActorLabel: 'Responsável pela taxa manual',
      manualTimeLabel: 'Data/hora da substituição',
      manualReasonLabel: 'Motivo da substituição',
      context: {
        PROVISION: 'Provisão',
        REVALUATION: 'Reavaliação',
        SETTLEMENT: 'Liquidação',
      },
      source: {
        IDENTITY: 'Identidade',
        PTAX: 'PTAX',
        MANUAL: 'Manual',
      },
    },
    journalDetails: {
      title: 'Detalhes do lançamento',
      description: 'Cabeçalho, linhas e evidência contábil do lançamento.',
      loading: 'Carregando lançamento...',
      error: 'Não foi possível carregar o lançamento.',
      retry: 'Tentar novamente',
      dateLabel: 'Data',
      statusLabel: 'Status',
      documentTypeLabel: 'Tipo de documento',
      memoLabel: 'Histórico',
      linesTitle: 'Linhas contábeis',
      accountLabel: 'Conta',
      debitLabel: 'Débito',
      creditLabel: 'Crédito',
      emptyLines: 'Nenhuma linha contábil encontrada.',
    },
    originLink: {
      title: 'Vínculos de origem',
      description:
        'Confirme que um registro de subrazão e um lançamento importado do histórico são o mesmo evento econômico.',
      ledgerSafetyNotice:
        'Esta tela grava apenas a linha de vínculo. Nenhum lançamento contábil é criado, revertido ou alterado.',
      tabs: {
        queue: 'Fila de registros',
        queueDescription:
          'Registro → lançamento: registros de subrazão ainda sem lançamento vinculado.',
        journals: 'Lançamentos importados',
        journalsDescription:
          'Lançamento → registro: lançamentos históricos e os vínculos que já carregam.',
      },
      filters: {
        targetKindAll: 'Todos os tipos de registro',
        coverageStateAll: 'Toda a cobertura',
        linkStateAll: 'Vinculados e não vinculados',
        linkStateLinked: 'Somente vinculados',
        linkStateUnlinked: 'Somente não vinculados',
        lifecycleRoleAll: 'Todas as etapas',
        searchPlaceholder: 'Buscar por número, histórico ou parte',
        memoSearchPlaceholder: 'Filtrar texto no histórico',
        bookPlaceholder: 'Selecione o livro',
        periodPlaceholder: 'Todos os períodos',
        datePlaceholder: 'Período de datas',
      },
      prompts: {
        selectEntityTitle: 'Selecione uma entidade',
        selectEntityDescription:
          'Escolha a entidade cujo histórico foi importado para ver a fila de registros e os lançamentos importados.',
        selectBook: 'Selecione o livro para listar os lançamentos importados.',
        loading: 'Carregando...',
        error: 'Erro ao carregar os dados de vínculo de origem.',
        emptyQueue: 'Nenhum registro pendente de vínculo para os filtros selecionados.',
        emptyJournals: 'Nenhum lançamento importado encontrado para os filtros selecionados.',
      },
      summary: {
        totalUnlinked: 'Registros sem vínculo',
        totalJournals: 'Lançamentos importados',
        linkedJournals: 'Com vínculo',
        unlinkedJournals: 'Sem vínculo',
      },
      targetKinds: {
        AP_BILL_ACCRUAL: 'Competência de conta a pagar',
        AP_PAYMENT_CLEARING: 'Baixa de pagamento',
        AR_INVOICE_ACCRUAL: 'Competência de fatura',
        CASH_MOVEMENT: 'Movimento de caixa',
      },
      targetKindHints: {
        AP_BILL_ACCRUAL:
          'A conta a pagar foi reconhecida no subrazão (accrual), mas ainda não tem o lançamento contábil de competência vinculado.',
        AP_PAYMENT_CLEARING:
          'Um pagamento de conta a pagar ainda sem o lançamento de baixa (liquidação) vinculado.',
        AR_INVOICE_ACCRUAL:
          'A fatura foi reconhecida no subrazão (accrual), mas ainda não tem o lançamento contábil de competência vinculado.',
        CASH_MOVEMENT: 'Uma transação bancária ou de cartão ainda sem vínculo de liquidação.',
      },
      openOriginal: 'Abrir registro original em nova aba',
      importNotes: {
        ACCRUAL_UNRESOLVED: {
          label: 'Sem lançamento determinado',
          description:
            'O importador não conseguiu determinar um único lançamento de competência para este registro (candidatos ambíguos ou nenhum candidato encontrado). Resolva vinculando manualmente aqui.',
        },
        ACCRUAL_LINK_UNDETERMINABLE: {
          label: 'Vínculo indeterminável',
          description:
            'O importador encontrou um lançamento candidato, mas o vínculo foi retido porque o mesmo lançamento também foi reivindicado por outro caso (ou exigiria mais de um lançamento, o que o sistema não representa). Um humano precisa decidir a quem o lançamento pertence.',
        },
        ACCRUAL_OUTSIDE_WINDOW: {
          label: 'Fora da janela de importação',
          description:
            'A data do registro está fora do intervalo declarado da importação, então nenhuma tentativa automática de vínculo foi feita.',
        },
        AMBIGUOUS: {
          label: 'Múltiplos candidatos',
          description:
            'Mais de um lançamento importado bateu com este registro e o importador não escolheu entre eles. Revise os candidatos e vincule manualmente.',
        },
        UNMATCHED: {
          label: 'Nenhum candidato encontrado',
          description: 'Nenhum lançamento importado bateu com este registro.',
        },
        DIVERGENT: {
          label: 'Divergência com o manifesto',
          description:
            'O matcher determinístico e o manifesto aprovado indicam lançamentos diferentes para este caso. O conflito bloqueia a importação e precisa ser resolvido manualmente.',
        },
        AP_VENDOR_UNRESOLVED: {
          label: 'Fornecedor não identificado',
          description:
            'Não existe um fornecedor cadastrado para o documento informado; a conta foi criada sem fornecedor vinculado.',
        },
        AR_INVOICE_LINK_CONTESTED: {
          label: 'Lançamento disputado por outra fatura',
          description:
            'O lançamento que corresponderia a esta fatura também é reivindicado por outra fatura concorrente. Nenhum vínculo foi criado automaticamente.',
        },
        CUSTOMER_DOCUMENT_UNRESOLVED: {
          label: 'Documento do cliente não identificado',
          description: 'O documento do cliente informado na fatura não foi identificado.',
        },
        CUSTOMER_UNIDENTIFIABLE: {
          label: 'Cliente não identificável',
          description: 'Não foi possível identificar o cliente da fatura pelos dados disponíveis.',
        },
        CUSTOMER_CREATION_NOT_AUTHORIZED: {
          label: 'Criação de cliente não autorizada',
          description:
            'O cliente não existe no cadastro e esta etapa não está autorizada a criá-lo automaticamente.',
        },
      },
      coverage: {
        candidatesAvailableBadge: 'Candidatos disponíveis',
        inCoverageNoMatchBadge: 'Sem correspondência',
        outOfCoverageBadge: 'Fora da cobertura',
        inCoverageNoMatchTitle: 'Nenhum candidato sugerido',
        inCoverageNoMatchDescription:
          'Existem lançamentos importados para este intervalo, mas nenhum bateu com o registro. Busque manualmente pelo lançamento correto.',
        outOfCoverageTitle: 'Fora da cobertura da importação',
        outOfCoverageDescription:
          'A data do registro está fora do intervalo já importado, então não existe lançamento para vincular. Isso não se resolve nesta tela: é preciso rodar uma importação de histórico mais ampla.',
        boundsLabel: 'Cobertura importada',
        boundsRange: '{{from}} a {{to}}',
        boundsUnknown: 'Nenhum lançamento importado para esta entidade e livro.',
        recordDateLabel: 'Data do registro',
      },
      manualSearch: {
        label: 'Busca manual',
        placeholder: 'Número do documento, histórico ou valor',
        action: 'Buscar',
        clear: 'Limpar busca',
        resultsTitle: 'Resultados da busca manual',
      },
      queue: {
        table: {
          record: 'Registro',
          kind: 'Tipo',
          party: 'Parte',
          date: 'Data',
          amount: 'Valor',
          coverage: 'Cobertura',
          candidates: 'Candidatos',
          importNote: 'Nota da importação',
          actions: 'Ações',
        },
        actions: {
          link: 'Vincular',
          view: 'Ver candidatos',
          audit: 'Auditoria',
          crossToJournals: 'Ver nos lançamentos',
        },
      },
      journals: {
        table: {
          date: 'Data',
          journalNumber: 'Lançamento',
          memo: 'Histórico',
          related: 'Relacionados (sugestão)',
          amount: 'Valor',
          period: 'Período',
          links: 'Vínculos',
          candidates: 'Candidatos',
          actions: 'Ações',
        },
        noLinks: 'Sem vínculo',
        orderByLabel: 'Ordenar por',
        orderOptions: {
          DATE_DESC: 'Data: mais recente',
          DATE_ASC: 'Data: mais antiga',
          AMOUNT_DESC: 'Valor: maior',
          AMOUNT_ASC: 'Valor: menor',
          HISTORICAL_ASC: 'Histórico: A–Z',
          HISTORICAL_DESC: 'Histórico: Z–A',
        },
        noRelated: 'Sem sugestão',
        lifecycleRoles: {
          ACCRUAL: 'Competência',
          CLEARING: 'Baixa',
        },
        relatedDocument: 'Documento {{documents}}',
        sameAmount: 'Mesmo valor',
        differentAmount: 'Valor diferente',
        linksCount: '{{count}} vínculo(s)',
        fromImport: 'Da importação',
        fromConsole: 'Do console',
        linkedAt: 'Vinculado em {{date}}',
        compoundHint:
          'Um lançamento de origem composto pode liquidar vários títulos — vários vínculos aqui é o comportamento correto.',
        actions: {
          viewJournal: 'Ver linhas do lançamento {{journalId}}',
          link: 'Vincular registro',
          unlink: 'Remover vínculo',
          audit: 'Auditoria',
          crossToQueue: 'Ver na fila',
        },
        journalDetailSubtitle: 'Lançamento {{journalId}}',
      },
      drawer: {
        titleRecordToJournal: 'Vincular registro a um lançamento importado',
        titleJournalToRecord: 'Vincular lançamento importado a um registro',
        recordSection: 'Registro',
        journalSection: 'Lançamento',
        candidatesTitle: 'Candidatos sugeridos',
        openRecord: 'Ver registro',
        journalDate: 'Data do lançamento',
        recordDescription: 'Descrição',
        recordDateKinds: {
          COMPETENCY: 'Data de competência',
          ISSUE: 'Data de emissão',
          PAID: 'Data de pagamento',
          SCHEDULED: 'Data agendada',
          POSTED: 'Data de lançamento bancário',
        },
        candidateScopes: {
          accountsPayable: 'Contas a pagar',
          bankTransactions: 'Transações bancárias',
        },
        candidateRank: 'Sugestão #{{rank}}',
        candidateScore: 'Aderência {{score}}',
        signalsTitle: 'Sinais',
        signalMatched: 'confere',
        signalUnmatched: 'diverge',
        select: 'Selecionar',
        selected: 'Selecionado',
        changeSelection: 'Trocar seleção',
        readOnlyNotice:
          'Você tem acesso somente leitura a vínculos de origem. É possível consultar candidatos, mas não asserir vínculos.',
        allocationLabel: 'Valor alocado',
        allocationHelp:
          'Alocação parcial é permitida; a soma das alocações não pode exceder o valor da transação.',
        reasonLabel: 'Motivo',
        reasonHelp:
          'Descreva por que este e não outro. O motivo fica registrado na trilha de auditoria.',
        reasonPlaceholder: 'Descreva a evidência que sustenta este vínculo',
        reasonRequired: 'Informe o motivo para concluir.',
        preflightRunning: 'Verificando...',
        preflightError: 'Erro ao verificar o vínculo.',
        confirm: 'Confirmar vínculo',
        confirming: 'Vinculando...',
        cancel: 'Cancelar',
        submitError: 'Erro ao registrar o vínculo.',
        loadError: 'Erro ao carregar candidatos.',
      },
      pagination: {
        summary: 'Página {{page}} de {{pages}} — {{total}} registro(s)',
      },
      warnings: {
        title: 'Divergências (não impedem o vínculo)',
        acknowledgeHint: 'Confirme as divergências marcadas para prosseguir.',
        informationalHint: 'As demais são informativas e não exigem confirmação.',
        acknowledge: 'Estou ciente',
        journalValue: 'Lançamento',
        recordValue: 'Registro',
        codes: {
          ORIGIN_LINK_AMOUNT_MISMATCH: 'Valores diferentes',
          ORIGIN_LINK_DATE_MISMATCH: 'Datas diferentes',
          ORIGIN_LINK_PERIOD_CLOSED: 'Período fechado — não impede o vínculo',
          ORIGIN_LINK_PARTY_MISMATCH: 'Partes diferentes',
          ORIGIN_LINK_PARTIAL_ALLOCATION: 'Alocação parcial',
        },
      },
      errors: {
        title: 'Impedimentos',
        codes: {
          ORIGIN_LINK_JOURNAL_NOT_FOUND: 'Lançamento não encontrado',
          ORIGIN_LINK_JOURNAL_NOT_HISTORICAL:
            'Lançamento não veio de uma importação de histórico e não é elegível',
          ORIGIN_LINK_JOURNAL_NOT_POSTED: 'Lançamento não está contabilizado',
          ORIGIN_LINK_JOURNAL_SLOT_TAKEN: 'A vaga deste lançamento já está ocupada',
          ORIGIN_LINK_RECORD_NOT_FOUND: 'Registro não encontrado',
          ORIGIN_LINK_RECORD_ALREADY_LINKED: 'Registro já está vinculado',
          ORIGIN_LINK_ENTITY_MISMATCH: 'Entidades diferentes',
          ORIGIN_LINK_BOOK_MISMATCH: 'Livros diferentes',
          ORIGIN_LINK_ALLOCATION_EXCEEDS_TRANSACTION:
            'A alocação excede o valor da transação de caixa',
          ORIGIN_LINK_JOURNAL_HAS_NO_SETTLEMENT:
            'Vincule primeiro o pagamento a este lançamento — o movimento de caixa liquida o pagamento, não o lançamento',
          ORIGIN_LINK_SETTLEMENT_AMBIGUOUS:
            'Este lançamento liquida mais de um título; é preciso indicar qual deles o movimento de caixa liquida',
          ORIGIN_LINK_REASON_REQUIRED: 'Motivo obrigatório',
          ORIGIN_LINK_WARNING_NOT_ACKNOWLEDGED: 'Há divergências não confirmadas',
          ORIGIN_LINK_POSTING_NOT_FOUND: 'Linha de vínculo não encontrada',
        },
        slotHolder: {
          title: 'Este lançamento já está vinculado a:',
          description:
            'Resultado esperado, não um defeito: outro registro ocupa a vaga deste lançamento. Abra o registro para decidir qual deve ficar com o vínculo.',
          open: 'Abrir registro',
        },
      },
      unlink: {
        title: 'Remover vínculo de origem',
        description:
          'A linha de vínculo será apagada definitivamente; apenas o evento de auditoria permanece. Nenhum lançamento contábil é criado, revertido ou alterado.',
        reasonLabel: 'Motivo',
        reasonPlaceholder: 'Descreva por que este vínculo deve ser removido',
        reasonRequired: 'Informe o motivo para remover o vínculo.',
        confirm: 'Remover vínculo',
        confirming: 'Removendo...',
        cancel: 'Cancelar',
        error: 'Erro ao remover o vínculo.',
      },
      events: {
        title: 'Trilha de auditoria',
        description: 'O que o operador estava vendo quando decidiu.',
        empty: 'Nenhum evento registrado.',
        loading: 'Carregando eventos...',
        error: 'Erro ao carregar a trilha de auditoria.',
        table: {
          date: 'Data',
          action: 'Ação',
          actor: 'Responsável',
          record: 'Registro',
          journal: 'Lançamento',
          reason: 'Motivo',
          evidence: 'Evidência vista',
        },
        actions: {
          LINK: 'Vínculo',
          UNLINK: 'Remoção',
        },
        suggestionSources: {
          RANKED_SUGGESTION: 'Sugestão sugerida (#{{rank}})',
          MANUAL_SEARCH: 'Busca manual',
        },
        acknowledgedWarnings: 'Divergências aceitas',
        journalSnapshot: 'Lançamento no momento da decisão',
        recordSnapshot: 'Registro no momento da decisão',
        allocatedAmount: 'Valor alocado',
        close: 'Fechar',
      },
    },
    ledger: {
      title: 'Razão geral',
      description: 'Visualize lançamentos contábeis por conta, livro e período.',
      emptyState: 'Nenhum lançamento encontrado para os filtros selecionados.',
      filters: {
        movementLabel: 'Movimentação',
        movementPlaceholder: 'Filtrar contas',
        withMovement: 'Somente contas com movimento',
        withoutMovement: 'Somente contas sem movimento',
        all: 'Todas as contas',
        accountLabel: 'Conta (opcional)',
        accountPlaceholder: 'Filtrar por conta',
        accountsSelected: '{{count}} contas selecionadas',
        periodTag: 'Período {{period}}',
        dateFromLabel: 'Data inicial',
        dateToLabel: 'Data final',
        dateFromPlaceholder: 'dd/mm/aaaa',
        dateToPlaceholder: 'dd/mm/aaaa',
        amountMinLabel: 'Valor mín.',
        amountMaxLabel: 'Valor máx.',
        amountMinPlaceholder: '0,00',
        amountMaxPlaceholder: '0,00',
        orderByLabel: 'Ordenar por',
        orderByAccount: 'Conta contábil',
        orderByDate: 'Data',
        orderByDebit: 'Débito',
        orderByCredit: 'Crédito',
        orderByBalance: 'Saldo',
        bookPlaceholder: 'Selecione o livro',
        periodPlaceholder: 'Selecione o período',
      },
      prompts: {
        selectEntity: 'Selecione uma entidade para ver o razão.',
        selectEntityTitle: 'Selecione uma entidade',
        selectEntityDescription:
          'Selecione uma entidade para ver o razão. Escolha uma entidade para consultar seus lançamentos por conta, livro e período.',
        selectBookAndPeriod: 'Informe livro e período (conta é opcional) para carregar o razão.',
        loading: 'Carregando razão...',
        noAccounts: 'Nenhuma conta encontrada para os filtros selecionados.',
        error: 'Erro ao carregar razão',
        accessRestricted: 'Acesso restrito',
        loadButton: 'Carregar razão',
      },
      table: {
        index: '#',
        date: 'Data',
        account: 'Conta contábil',
        documentType: 'Tipo doc.',
        documentNumber: 'Número',
        copyDocumentNumber: 'Copiar número completo {{number}}',
        documentNumberCopied: 'Número completo copiado.',
        documentNumberCopyError: 'Não foi possível copiar o número completo.',
        memo: 'Histórico',
        debit: 'Débito',
        credit: 'Crédito',
        balance: 'Saldo',
        transactionAmount: 'Valor da transação',
        summary: {
          book: 'Livro:',
          period: 'Período:',
          opening: 'Saldo inicial:',
          debit: 'Débitos:',
          credit: 'Créditos:',
          closing: 'Saldo final:',
          entries: 'Lançamentos:',
        },
      },
      view: {
        byAccount: 'Por conta',
        chronological: 'Linha do tempo',
      },
      panel: {
        title: 'Lançamentos da conta',
        movementBadge: 'Movimentação',
        periodLabel: 'Período: {{period}}',
        entriesCount: '{{count}} lançamento',
        entriesCount_plural: '{{count}} lançamentos',
        empty: 'Nenhum lançamento encontrado para esta conta.',
        aiSummaryTitle: 'Resumo IA',
        aiSummaryPatternsLabel: 'Padrões',
        aiSummaryPatternsHighlight: 'Maior parte dos lançamentos',
        aiSummaryPatternsText: 'está concentrada em poucos eventos de negócio recorrentes.',
        aiSummaryAnomaliesLabel: 'Anomalias',
        aiSummaryAnomaliesText: 'nenhuma variação significativa em relação ao período anterior.',
        aiSummaryCompositionLabel: 'Composição',
        aiSummaryCompositionText:
          'um conjunto pequeno de contrapartes explica a maior parte do saldo.',
        aiSummaryError: 'Não foi possível gerar o resumo por IA.',
        searchPlaceholder: 'Buscar nos lançamentos...',
        amountFilterAll: 'Todos os valores',
        amountFilterGt1k: '> R$ 1.000',
        amountFilterGt5k: '> R$ 5.000',
        footerSummary: '{{visible}} of {{total}} entries visible',
      },
      actions: {
        export: 'Exportar',
        exportCsv: 'Excel (CSV)',
        exportPdf: 'PDF',
        exportXlsx: 'Excel',
        print: 'Imprimir',
      },
      presets: {
        title: 'Visualizações do razão',
        description: 'Configure como este plano de contas é lido sem alterar os lançamentos.',
        detailed: 'Detalhado',
        manage: 'Visualizações',
        saveCurrent: 'Salvar visualização atual',
        name: 'Nome',
        groupSameDay: 'Agrupar lançamentos do mesmo dia',
        foldedRoots: 'Agrupar contas filhas',
        foldedRootsHelper:
          'Mostra a conta-mãe em uma única linha em vez de uma linha por fornecedor, cliente ou funcionário. Os totais não mudam.',
        slotSearchPlaceholder: 'Buscar por código ou nome da conta',
        unmappedSlotHelper: 'Sem conta mapeada nesta versão do plano',
        hideReversedPairs: 'Ocultar pares estornados',
        hideReversedPairsTooltip:
          'Oculta um lançamento e o seu estorno somente quando os dois estão no mesmo período consultado. Se o estorno estiver em outro período, o lançamento original continua visível, com o selo "revertido em".',
        makeDefault: 'Tornar padrão',
        defaultBadge: 'Padrão',
        delete: 'Excluir',
        deleteTitle: 'Excluir visualização?',
        deleteDescription:
          'Links compartilhados que usam esta visualização deixarão de funcionar. Os lançamentos não serão alterados.',
        saved: 'Visualização salva.',
        deletedLinkError:
          'Esta visualização do razão foi excluída. Escolha outra visualização ou Detalhado.',
        wrongChartError: 'Esta visualização pertence a outro plano de contas.',
        invalidRowModeError: 'Modo de linhas inválido. Use Lançamentos ou Linhas.',
      },
      rowMode: {
        label: 'Linhas do razão',
        grouped: 'Lançamentos',
        lines: 'Linhas',
      },
      grouped: {
        source: 'Origem',
        unknownSource: 'Origem não informada',
        documentCount: '{{count}} documento',
        documentCount_plural: '{{count}} documentos',
        documentCount_other: '{{count}} documentos',
        reversedOn: 'revertido em {{date}}',
        loadingMembers: 'Carregando lançamentos...',
        membersError: 'Não foi possível carregar os lançamentos deste agrupamento.',
        postingSources: {
          arInvoice: 'Fatura de cliente',
          arInvoiceAccrual: 'Apropriação de fatura de cliente',
          arInvoiceReversal: 'Estorno de fatura de cliente',
          arNfseIssReclassification: 'Reclassificação de ISS da NFS-e',
          arRevenueRecognition: 'Reconhecimento de receita',
          arAggregateReclassification: 'Reclassificação de faturamento agregado',
          arAggregateWithholding: 'Retenções da nota do faturamento agregado',
          arContractChildReclassification: 'Reclassificação entre contas do contrato',
          arTaxCollected: 'Imposto sobre recebimento',
          arSettlementReconciliation: 'Conciliação de repasse',
          arRailSettlement: 'Liquidação de recebíveis',
          arSettlementPayableAdjustment: 'Ajuste de obrigação de repasse',
          arInternalTransfer: 'Transferência interna',
          arDebitNote: 'Nota de débito',
          manualEntry: 'Entrada manual',
          reversal: 'Estorno de lançamento',
          payableProvision: 'Provisão de conta a pagar',
          payablePayment: 'Pagamento de conta a pagar',
          apFxRevaluation: 'Reavaliação cambial de conta a pagar',
          apRemediation: 'Correção de conta a pagar',
          apBillDeferral: 'Diferimento de conta a pagar',
          apBillDeferralCancellation: 'Cancelamento de diferimento de conta a pagar',
          apBillDeferralReclassification: 'Reclassificação de diferimento de conta a pagar',
          apBillDeferralRefund: 'Reembolso de diferimento de conta a pagar',
          apClientRecoverableWriteOff: 'Baixa de valor recuperável de cliente',
          receivableReceipt: 'Recebimento de conta a receber',
          statutoryPaymentClearing: 'Baixa de pagamento estatutário',
          statutoryAutoProvision: 'Provisão estatutária automática',
          statutoryAutoProvisionReclassification: 'Reclassificação de provisão estatutária',
          statutoryBypassReclassification: 'Reclassificação estatutária direta',
          taxLiabilityRailMigration: 'Migração de trilho de obrigação tributária',
          glOnboardingImport: 'Importação inicial do razão',
          historicalLedgerImport: 'Importação histórica do razão',
          revenueClassificationBackfill: 'Correção histórica de classificação de receita',
          apPaymentSettlement: 'Liquidação de pagamento de conta a pagar',
          creditCardSettlement: 'Liquidação de cartão de crédito',
          offsetRootRemediation: 'Correção de raiz de contrapartida',
          assetOpeningBalance: 'Saldo de abertura de ativo (carga de demonstração)',
          expenseAccrual: 'Apropriação de despesa',
          fxRemeasurement: 'Remensuração cambial',
          payroll: 'Folha de pagamento',
          statutoryAccountingFallback: 'Provisão tributária a classificar',
          fixedAssetCapitalization: 'Capitalização de ativo imobilizado',
          fixedAssetDepreciation: 'Depreciação de ativo imobilizado',
          fixedAssetDisposal: 'Baixa de ativo imobilizado',
          fixedAssetTransfer: 'Transferência de imobilizado em andamento',
          fixedAssetPisCofinsRecoverabilityAllowance:
            'Provisão de recuperabilidade de PIS/COFINS sobre imobilizado',
          leaseRecognition: 'Reconhecimento de arrendamento',
          leaseLiabilityReclassification: 'Reclassificação de passivo de arrendamento',
          leaseRemeasurement: 'Remensuração de arrendamento',
          intangibleAllocationCorrection: 'Correção de alocação ao intangível',
          intangibleProjectGoLive: 'Entrada em operação de projeto intangível',
          intangibleProjectWriteOff: 'Baixa de projeto intangível',
          revenueTaxProvision: 'Provisão de PIS/COFINS sobre receita',
          revenueTaxProvisionReversal: 'Estorno de provisão de PIS/COFINS',
          revenueTaxCashRelease: 'Realização de PIS/COFINS no recebimento',
          revenueTaxCashReleaseReversal: 'Estorno de realização de PIS/COFINS',
          costProvision: 'Provisão de custo de receita',
          costProvisionReversal: 'Estorno de provisão de custo de receita',
          costProvisionClose: 'Encerramento de provisão de custo de receita',
          costMatchReclassification: 'Baixa de provisão de custo por conta a pagar',
          costMatchUndo: 'Baixa de provisão de custo desfeita',
          creditCardProviderReclassification: 'Reclassificação de conta de cartão de crédito',
          managerialChartSwap: 'Troca de plano gerencial',
          taxAssessment: 'Apuração de tributos',
        },
      },
    },
    trialBalance: {
      title: 'Balancete',
      description: 'Resumo dos saldos por conta contábil.',
      emptyState: 'Nenhum saldo encontrado para os filtros selecionados.',
      prompts: {
        selectEntity: 'Selecione uma entidade para ver o balancete.',
        selectEntityTitle: 'Selecione uma entidade para ver o balancete.',
        selectEntityDescription:
          'Escolha uma entidade para consultar seus saldos por conta contábil, livro e período.',
        selectBookAndPeriod: 'Informe livro e período para carregar o balancete.',
        loading: 'Carregando balancete...',
        error: 'Erro ao carregar balancete',
      },
      filters: {
        bookPlaceholder: 'Selecione o livro',
        periodPlaceholder: 'Selecione o período',
        accountPlaceholder: 'Filtrar por conta',
        amountMinPlaceholder: '0,00',
        amountMaxPlaceholder: '0,00',
        amountRangeLabel: 'Faixa de valores',
        noMatches: 'Nenhuma conta corresponde aos filtros de conta ou valor.',
      },
      syntheticBadge: 'Sintética',
      movementsRestricted: 'Restrito',
      movementsRestrictedHint:
        'Os saldos inicial e final estão disponíveis, mas os movimentos desta conta são confidenciais.',
      folding: {
        detailed: 'Detalhado',
        marker_one: '{{count}} conta dobrada',
        marker_other: '{{count}} contas dobradas',
        expand: 'Mostrar contas dobradas',
        loadingChildren: 'Carregando contas dobradas',
        editInLedger: 'Editar visualizações no razão',
      },
      periodLabel: 'Período',
      showPeriod: 'Mostrar',
      hidePeriod: 'Esconder',
      table: {
        account: 'Conta',
        code: 'Código',
        rollup: 'Rollup',
        opening: 'Saldo inicial',
        debits: 'Débitos',
        credits: 'Créditos',
        closing: 'Saldo final',
        netBalance: 'Saldo líquido',
      },
      actions: {
        export: 'Exportar',
        print: 'Imprimir',
        shareLink: 'Link compartilhável',
        exportEmpty: 'Nenhum dado para exportar.',
        exportSuccess: 'Exportação para Excel iniciada.',
        exportError: 'Falha ao exportar o balancete.',
        shareLinkCopied: 'Link copiado para a área de transferência.',
        shareLinkError: 'Não foi possível copiar o link.',
        exportPdfSuccess: 'Exportação para PDF iniciada.',
        exportPdfError: 'Falha ao exportar o balancete em PDF.',
      },
    },
    balanceSheet: {
      title: 'Balanço patrimonial',
      description:
        'Resumo dos saldos agregados por grupos de rollup (ativos, passivos e patrimônio líquido).',
      emptyState: 'Nenhum saldo encontrado para os filtros selecionados.',
      prompts: {
        selectEntity: 'Selecione uma entidade para ver o balanço.',
        selectBookAndPeriod: 'Informe livro e período para carregar o balanço.',
        loading: 'Carregando balanço...',
        error: 'Erro ao carregar balanço',
      },
    },
    incomeStatement: {
      prompts: {
        selectEntity: 'Selecione uma entidade para ver a DRE.',
        selectBookAndPeriod: 'Informe livro e período para carregar a DRE.',
      },
    },
    periodPlanning: {
      title: 'Períodos Contábeis',
      description:
        'Visualize e planeje os períodos contábeis por entidade e livro, com base no calendário.',
      loading: 'Carregando planejamento de períodos...',
      loadButton: 'Carregar períodos',
      emptyState: 'Nenhum período encontrado para a combinação de entidade e livro.',
      error: 'Erro ao carregar planejamento de períodos.',
      prompts: {
        selectEntity: 'Selecione uma entidade para ver o planejamento de períodos.',
        selectBook: 'Selecione um livro para ver o planejamento de períodos.',
      },
      summary: {
        entity: 'Entidade:',
        book: 'Livro:',
        calendar: 'Calendário:',
        calendarUnknown: 'Calendário não definido',
        periodicity: 'Periodicidade:',
        fiscalYearStartMonth: 'Mês inicial do ano fiscal:',
      },
    },
    calendars: {
      title: 'Calendários contábeis',
      loading: 'Carregando calendários...',
      newButton: 'Novo calendário',
      editButton: 'Editar',
      table: {
        name: 'Nome',
        timeZone: 'Time zone',
        fiscalYearStartMonth: 'Início Fiscal (mês)',
        periodicity: 'Periodicidade',
        status: 'Status',
        actions: 'Ações',
      },
      form: {
        createTitle: 'Novo calendário contábil',
        editTitle: 'Editar calendário contábil',
        fields: {
          name: 'Nome',
          namePlaceholder: 'Ex: Calendário fiscal',
          timeZone: 'Fuso horário',
          timeZonePlaceholder: 'Ex: America/Sao_Paulo',
          fiscalYearStartMonth: 'Mês inicial do ano fiscal (1–12)',
          periodicity: 'Periodicidade',
          periodicityMonthly: 'Mensal (12 meses)',
          periodicityQuarterly: 'Trimestral (4 trimestres)',
          periodicityWeekly: 'Semanal (52–53 semanas)',
          periodicityThirteenPeriods: '13 períodos (4 semanas cada)',
          periodicity445: '4-4-5 (varejo)',
          periodicity454: '4-5-4',
          periodicity544: '5-4-4',
          status: 'Status',
          statusActive: 'Ativo',
          statusInactive: 'Inativo',
        },
      },
    },
    periods: {
      title: 'Períodos contábeis',
      description:
        'Visualize, crie e gerencie períodos contábeis por entidade e livro. Feche, reabra ou trave períodos conforme o fluxo de fechamento.',
      loading: 'Carregando períodos...',
      newButton: 'Novo período',
      editButton: 'Editar',
      filters: {
        bookPlaceholder: 'Selecione o livro',
      },
      table: {
        period: 'Período',
        entity: 'Entidade',
        book: 'Livro',
        startDate: 'Início',
        endDate: 'Fim',
        status: 'Status',
        actions: 'Ações',
      },
      prompts: {
        selectEntity: 'Selecione uma entidade para ver os períodos.',
        selectBook: 'Selecione um livro para ver os períodos.',
      },
      statusLabels: {
        open: 'Aberto',
        closed: 'Fechado',
        locked: 'Travado',
      },
      actions: {
        createPeriod: 'Criar período',
        generateYear: 'Gerar períodos do ano',
        genericError: 'Não foi possível atualizar o período.',
        aiPostingBlocked:
          'Há contas a pagar com lançamento da IA ainda não revisado ou pendente nesta competência; revise o card "Postagens contábeis a revisar" no checklist de fechamento.',
        close: 'Fechar período',
        reopen: 'Reabrir período',
        lock: 'Travar período',
        reopenConfirm:
          'Reabrir este período também irá reabrir todos os períodos fechados até o período atual deste livro/entidade. Deseja continuar?',
      },
      generateYear: {
        title: 'Gerar períodos do ano fiscal',
        description:
          'Cria todos os períodos do ano para a entidade e livro selecionados (ex.: jan–dez). Períodos já existentes são ignorados. Novos períodos ficam abertos para lançamentos retroativos.',
        yearLabel: 'Ano fiscal',
        yearPlaceholder: 'Ex: 2024',
        submit: 'Gerar',
        success: 'Períodos criados: {{created}}. Já existentes (ignorados): {{skipped}}.',
        error: 'Não foi possível gerar os períodos.',
      },
    },
    books: {
      title: 'Livros contábeis',
      description: 'Gerencie os livros contábeis da sua organização.',
      emptyState: 'Nenhum livro encontrado.',
      loading: 'Carregando livros...',
      error: 'Erro ao carregar livros',
      footerCount_one: '{{count}} livro',
      footerCount_other: '{{count}} livros',
      searchPlaceholder: 'Buscar por código ou nome...',
      filters: {
        all: 'Todos',
        active: 'Ativos',
        inactive: 'Inativos',
        entityAll: 'Todas as entidades',
        status: 'Status',
      },
      actions: {
        create: 'Novo livro',
        edit: 'Editar',
        delete: 'Excluir',
        activate: 'Ativar',
        deactivate: 'Desativar',
      },
      form: {
        createTitle: 'Novo livro contábil',
        editTitle: 'Editar livro contábil',
        createDescription: 'Crie um novo livro contábil para a sua organização.',
        editDescription: 'Edite as informações do livro contábil.',
        lockedAfterPosting:
          'Este livro possui lançamentos contabilizados e não pode mais ser editado.',
        fields: {
          code: 'Código',
          codePlaceholder: 'Ex: LV001',
          name: 'Nome',
          namePlaceholder: 'Ex: Livro Fiscal',
          type: 'Tipo',
          typePlaceholder: 'Selecione o tipo',
          typeStatutory: 'Estatutário',
          typeTax: 'Fiscal',
          typeManagement: 'Gerencial',
          typeConsolidation: 'Consolidação',
          typeSandbox: 'Sandbox',
          scope: 'Escopo',
          scopePlaceholder: 'Selecione o escopo',
          scopeEntity: 'Entidade',
          scopeTenant: 'Grupo',
          reportingCurrency: 'Moeda de relatório',
          reportingCurrencyPlaceholder: 'Selecione a moeda',
          functionalCurrency: 'Moeda funcional',
          functionalCurrencyPlaceholder: 'Selecione a moeda',
          framework: 'Norma contábil',
          frameworkPlaceholder: 'Selecione a norma contábil',
          status: 'Status',
          statusPlaceholder: 'Selecione o status',
          statusActive: 'Ativo',
          statusInactive: 'Inativo',
          entity: 'Entidade',
          entityPlaceholder: 'Selecione a entidade',
          entityOptional: 'Sem vínculo',
          calendar: 'Calendário',
          calendarPlaceholder: 'Selecione o calendário',
          calendarOptional: 'Sem vínculo',
          chart: 'Plano de contas',
          chartPlaceholder: 'Selecione o plano de contas',
          chartNotNeededForMemo: 'Livros fiscais (TAX_BASIS) não usam plano de contas.',
          noPublishedCharts:
            'Nenhum plano de contas publicado disponível. Publique um plano de contas antes de vincular o livro a uma entidade.',
        },
      },
      table: {
        code: 'Código',
        name: 'Nome',
        type: 'Tipo',
        scope: 'Escopo',
        currency: 'Moeda',
        status: 'Status',
        actions: 'Ações',
      },
      values: {
        type: {
          statutory: 'Estatutário',
          tax: 'Fiscal',
          management: 'Gerencial',
          consolidation: 'Consolidação',
          sandbox: 'Simulação',
        },
        scope: {
          entity: 'Entidade',
          group: 'Grupo',
        },
        status: {
          active: 'Ativo',
          inactive: 'Inativo',
        },
      },
    },
    multicurrency: {
      title: 'Operações multimoeda',
      description: 'Cotações imutáveis, reavaliações por livro e exceções do fechamento.',
      refresh: 'Atualizar',
      manualQuote: 'Cotação manual',
      manualDescription: 'A cotação será criada pendente e exige aprovação independente.',
      enabledCurrencies: 'Moedas habilitadas',
      activeQuotes: 'Cotações ativas',
      openExceptions: 'Exceções abertas',
      quotes: 'Cotações e versões',
      exceptions: 'Exceções de reavaliação',
      pair: 'Par',
      purpose: 'Finalidade',
      date: 'Data solicitada',
      rate: 'Taxa',
      source: 'Fonte',
      status: 'Status',
      approve: 'Aprovar',
      period: 'Período',
      reason: 'Motivo',
      remediation: 'Remediação',
      from: 'Moeda base',
      to: 'Moeda de cotação',
      evidence: 'URL da evidência',
      actualRateAt: 'Data e hora observada da taxa',
      actualRateAtHelp:
        'O momento exato em que a taxa foi observada pela fonte — diferente da data contábil solicitada abaixo.',
      retry: 'Tentar novamente',
      loading: 'Carregando…',
      statuses: {
        ACTIVE: 'Ativa',
        PENDING_APPROVAL: 'Pendente de aprovação',
        SUPERSEDED: 'Substituída',
        REJECTED: 'Rejeitada',
        PREVIEWED: 'Pré-visualizada',
        RUNNING: 'Em execução',
        COMPLETED: 'Concluída',
        COMPLETED_WITH_EXCEPTIONS: 'Concluída com exceções',
        FAILED: 'Falhou',
      },
      noExceptions: 'Nenhuma exceção aberta.',
      loadError: 'Não foi possível carregar as operações multimoeda.',
      manualCreated: 'Cotação enviada para aprovação.',
      manualCreateError: 'Não foi possível criar a cotação manual.',
      quoteApproved: 'Cotação aprovada.',
      quoteApproveError: 'Não foi possível aprovar a cotação.',
      runs: 'Execuções de reavaliação',
      functionalCurrency: 'Moeda funcional',
      noRuns: 'Nenhuma execução de reavaliação.',
      runCreatedAt: 'Criada em',
      execute: 'Executar',
      runExecuted: 'Reavaliação executada.',
      runExecuteError: 'Não foi possível executar a reavaliação.',
      errors: {
        pairSame: 'As moedas base e de cotação devem ser diferentes.',
        rateInvalid: 'Informe uma taxa exata positiva.',
        reasonRequired: 'O motivo é obrigatório.',
        evidenceRequired: 'A URL da evidência é obrigatória.',
        dateRequired: 'A data solicitada é obrigatória.',
        actualRateAtRequired: 'A data e hora observada da taxa é obrigatória.',
      },
    },
  },
  periods: {
    form: {
      createTitle: 'Novo período',
      createDescription: 'Crie um período a partir do calendário da entidade/livro.',
      editTitle: 'Editar período',
      editDescription: 'Edite as informações do período.',
      fields: {
        periodId: 'ID do período',
        periodIdPlaceholder: 'Ex: 2024-01',
        startDate: 'Data inicial',
        endDate: 'Data final',
        entityId: 'Entidade',
        entityIdPlaceholder: 'Selecione a entidade',
        bookId: 'Livro',
        bookIdPlaceholder: 'Selecione o livro',
        fiscalYear: 'Ano fiscal',
        fiscalYearPlaceholder: 'Ex: 2024',
        periodOption: 'Período',
        periodOptionPlaceholder: 'Selecione o período',
      },
      createFromCalendar: {
        loadingPeriods: 'Carregando períodos...',
        noPeriods: 'Nenhum período definido para este ano. Verifique entidade, livro e ano.',
      },
    },
  },
  selectors: {
    accounts: {
      noneAvailable: 'Nenhuma conta disponível',
    },
    books: {
      noneAvailable: 'Nenhum livro disponível',
    },
    periods: {
      noneAvailable: 'Nenhum período disponível',
      currentPeriod: 'Ver período atual',
    },
  },
  actions: {
    glAccount: {
      actionLabel: 'Definir Conta Contábil',
      selectLabel: 'Conta Contábil',
      withSplitPrefix: 'com rateio de',
    },
  },
  /**
   * Consolidated cross-CoA rollup report (ALC-2000). Every stable error code the endpoint can
   * return is mapped here so a failure tells the user which account, version or rate to fix.
   */
  consolidatedRollup: {
    errors: {
      CONSOLIDATED_ROLLUP_SCOPES_REQUIRED: 'Selecione pelo menos uma entidade para consolidar.',
      CONSOLIDATED_ROLLUP_DUPLICATE_SCOPE:
        'A mesma entidade foi incluída duas vezes — remova a repetição para não contar o saldo em dobro.',
      CONSOLIDATED_ROLLUP_INVALID_ACCOUNTING_DATE:
        'A data de corte informada não existe no calendário (por exemplo, 30/02). Informe uma data real — o relatório não avança o corte para o mês seguinte.',
      CONSOLIDATED_ROLLUP_PERIOD_NOT_FOUND:
        'Uma das entidades não tem período aberto na data informada. Gere o período dessa entidade ou escolha outra data.',
      CONSOLIDATED_ROLLUP_REPORTING_CURRENCY_UNSUPPORTED:
        'A moeda de apresentação escolhida não está habilitada para contabilidade. Escolha outra moeda ou habilite-a no cadastro de moedas.',
      CONSOLIDATED_ROLLUP_INSUFFICIENT_VISIBILITY:
        'Seu acesso não cobre todas as contas desta consolidação, e um total consolidado parcial não avisa que está incompleto. Peça acesso às contas restritas (ou à folha) para emitir este relatório.',
      CONSOLIDATED_ROLLUP_ORPHANED_BALANCE:
        'Existem saldos contábeis apontando para contas que não existem mais. Eles não podem ser atribuídos a nenhum grupo de consolidação, e um total que os omitisse pareceria completo. Corrija esses registros antes de consolidar.',
      CONSOLIDATED_ROLLUP_ACCOUNT_UNMAPPED:
        'Há conta sem grupo de consolidação na versão do plano de contas. Mapeie a conta indicada na mensagem antes de consolidar — o relatório não omite saldos.',
      CONSOLIDATED_ROLLUP_EQUITY_TRANSLATION_UNSUPPORTED:
        'Há conta de patrimônio líquido em moeda funcional diferente da moeda de apresentação. A conversão exige camadas a taxas históricas e uma linha de ajuste acumulado de conversão (CTA), que este relatório não deriva. Consolide essa entidade na própria moeda funcional ou retire as contas de patrimônio dos grupos selecionados.',
      CONSOLIDATED_ROLLUP_INTRAGROUP_BALANCE_PRESENT:
        'Há posição intercompany em aberto em uma das entidades selecionadas. Saldos e resultados intragrupo precisam ser eliminados antes de apresentar um total como consolidado, e este relatório não faz a eliminação. Liquide a posição ou retire a entidade do escopo.',
      CONSOLIDATED_ROLLUP_CATEGORY_MISMATCH:
        'Um grupo de consolidação de balanço patrimonial recebeu conta de resultado (ou o inverso). Corrija o mapeamento: a taxa de câmbio aplicada seria a errada.',
      CONSOLIDATED_ROLLUP_RATE_UNAVAILABLE:
        'Falta a taxa de câmbio do par e da data indicados na mensagem. Cadastre a taxa (fechamento para balanço, média para resultado) — saldos em moedas diferentes nunca são somados sem conversão.',
    },
  },
  manualEntries: {
    title: 'Lançamentos manuais',
    subtitle: 'Rascunhos, lançamentos e estornos no razão.',
    newEntry: 'Novo lançamento',
    editorTitleNew: 'Novo lançamento manual',
    editorTitle: 'Lançamento manual',
    breadcrumbList: 'Lançamentos manuais',
    filters: {
      entity: 'Entidade',
      period: 'Período',
      periodPlaceholder: 'Selecione o período',
      numberPlaceholder: 'Ex.: LM-2026-0001',
      descriptionPlaceholder: 'Busque pelo histórico',
      createdByPlaceholder: 'Selecione o usuário',
      documentTypeAll: 'Todos os tipos',
      status: 'Status',
      statusAll: 'Todos',
      minimum: 'Mínimo',
      maximum: 'Máximo',
      debitMinimum: 'Débito mínimo',
      debitMaximum: 'Débito máximo',
      creditMinimum: 'Crédito mínimo',
      creditMaximum: 'Crédito máximo',
      applied: 'Filtros ativos',
      clearAll: 'Limpar filtros',
      remove: 'Remover filtro {{filter}}',
      filterNumber: 'Filtrar número',
      filterEntity: 'Filtrar entidade',
      filterPeriod: 'Filtrar período',
      filterDocumentType: 'Filtrar tipo',
      filterStatus: 'Filtrar status',
      filterCreatedBy: 'Filtrar usuário criador',
      filterDescription: 'Filtrar histórico',
      filterDebit: 'Filtrar débito',
      filterCredit: 'Filtrar crédito',
    },
    status: {
      DRAFT: 'Rascunho',
      POSTED: 'Lançado',
      REVERSED: 'Estornado',
      CANCELLED: 'Cancelado',
    },
    documentTypes: {
      MANUAL: 'Manual',
      ADJUSTMENT: 'Ajuste',
    },
    columns: {
      number: 'Número',
      date: 'Data',
      entity: 'Entidade',
      documentType: 'Tipo',
      status: 'Status',
      createdBy: 'Criado por',
      description: 'Histórico',
      debit: 'Débito',
      credit: 'Crédito',
    },
    sort: {
      tooltip: 'Clique para ordenar por essa coluna',
      sortBy: 'Ordenar por {{column}}{{direction}}',
      sortAsc: 'crescente',
      sortDesc: 'decrescente',
    },
    empty: 'Nenhum lançamento manual encontrado.',
    emptyFiltered: 'Nenhum lançamento corresponde aos filtros.',
    emptyFilteredDescription: 'Limpe os filtros para ver todos os lançamentos manuais.',
    loading: 'Carregando lançamentos manuais…',
    loadError: 'Não foi possível carregar os lançamentos manuais.',
    pagination: {
      page: 'Página {{page}} de {{totalPages}}',
      summary_one: 'Página {{page}} de {{totalPages}} • {{count}} resultado',
      summary_other: 'Página {{page}} de {{totalPages}} • {{count}} resultados',
    },
    header: {
      entity: 'Entidade',
      date: 'Data',
      documentType: 'Tipo de documento',
      book: 'Livro',
      bookPlaceholder: 'Definido pela entidade',
      currency: 'Moeda funcional',
      currencyPlaceholder: 'Definida pela entidade',
      description: 'Histórico',
      descriptionPlaceholder: 'Ex.: Provisão de férias, competência agosto/2026',
      draftBadge: 'Rascunho · {{entryNumber}}',
    },
    details: {
      title: 'Dados do lançamento',
      subtitle: 'Informe a entidade, a data e os dados gerais do lançamento.',
    },
    lines: {
      title: 'Linhas',
      add: 'Adicionar linha',
      remove: 'Remover linha',
      account: 'Conta',
      debit: 'Débito',
      credit: 'Crédito',
      description: 'Histórico da linha',
      dimensions: 'Dimensões',
      showDimensions: 'Mostrar dimensões da linha {{line}}',
      hideDimensions: 'Ocultar dimensões da linha {{line}}',
      costCenter: 'Centro de custo',
      costCenterPlaceholder: 'Selecione um centro de custo',
      department: 'Departamento',
      departmentPlaceholder: 'Selecione um departamento',
      managerialAccount: 'Conta gerencial',
      managerialAccountPlaceholder: 'Selecione uma conta gerencial',
      incomplete: 'Linha incompleta: informe a conta e um valor de débito ou crédito.',
      invalidAmount: 'Valor inválido. Use até duas casas decimais e um valor positivo.',
    },
    totals: {
      title: 'Totais',
      debit: 'Total débito',
      credit: 'Total crédito',
      debits: 'Débitos',
      credits: 'Créditos',
      difference: 'Diferença',
      differenceValue: 'Diferença de {{amount}}',
      balanced: 'Balanceado',
      unbalanced: 'Desbalanceado',
      empty: 'Sem valores',
      progressLabel: 'Progresso do balanceamento entre débitos e créditos',
      incomplete: 'Há linhas incompletas ou inválidas.',
    },
    validation: {
      title: 'Validações',
      entity: 'Entidade selecionada',
      date: 'Data informada',
      lines: 'Pelo menos duas linhas completas',
      balanced: 'Débitos e créditos balanceados',
    },
    attachments: {
      title: 'Anexos',
      empty: 'Nenhum anexo.',
      uploadedAt: 'Enviado em {{date}}',
      saveFirst: 'Salve o rascunho para anexar arquivos.',
      dropPrompt: 'Anexar memória de cálculo, planilha ou e-mail',
      dropHint: 'ou arraste aqui',
      tooLarge: 'O anexo excede o limite de 5 MB.',
      upload: 'Anexar arquivo',
      uploading: 'Enviando…',
      delete: 'Excluir anexo',
      toastUploaded: 'Anexo enviado.',
      toastDeleted: 'Anexo excluído.',
      confirmDelete: {
        title: 'Excluir anexo',
        description: 'O arquivo "{{fileName}}" será removido do lançamento.',
        confirm: 'Excluir anexo',
      },
    },
    actions: {
      save: 'Salvar rascunho',
      saving: 'Salvando…',
      preview: 'Pré-visualizar razão',
      post: 'Contabilizar',
      posting: 'Contabilizando…',
      reverse: 'Estornar',
      reversing: 'Estornando…',
      cancel: 'Voltar',
      openLedger: 'Abrir razão',
      reviewSourceDiscount: 'Revisar desconto fiscal da origem',
      reviewSourceDiscountNeedsAttachment:
        'Anexe o documento original enquanto o lançamento estiver em rascunho.',
      cancelDraft: 'Cancelar rascunho',
      cancelling: 'Cancelando…',
    },
    sourceDiscount: {
      title: 'Revisar desconto incondicional da origem',
      description:
        'Vincule a dedução somente ao documento original que declara o desconto, antes de qualquer evento futuro.',
      gross: 'Receita bruta',
      discount: 'Desconto documentado',
      net: 'Base líquida',
      evidence: 'Documento de origem',
      evidencePlaceholder: 'Selecione um anexo',
      code: 'Código da evidência',
      evidenceDescription: 'Descrição da evidência',
      statedOnSourceDocument: 'Confirmo que o desconto consta no documento original da operação.',
      independentOfFutureEvent:
        'Confirmo que o desconto não depende de pagamento, recebimento ou outro evento futuro.',
      confirm: 'Confirmar elegibilidade',
      saving: 'Confirmando…',
      cancel: 'Cancelar',
      done: 'Concluir',
      retry: 'Tentar novamente',
      loading: 'Verificando lançamento e documentos…',
      alreadyApproved: 'Esta fonte já possui uma decisão documental imutável.',
      successTitle: 'Elegibilidade registrada',
      success:
        'Elegibilidade do desconto registrada. Processe as provisões pendentes de PIS/COFINS.',
      errorTitle: 'Não foi possível registrar a elegibilidade',
      errors: {
        evidence: 'Selecione o documento de origem.',
        changed: 'O lançamento ou o documento mudou. Reabra a revisão e confirme os dados atuais.',
      },
      refusals: {
        SOURCE_NOT_FOUND: 'A origem não foi encontrada.',
        MANUAL_ENTRY_NOT_POSTED: 'Contabilize o lançamento antes de revisar o desconto.',
        SOURCE_JOURNAL_SCOPE_AMBIGUOUS:
          'A origem possui mais de um diário contábil elegível. Revise o escopo antes de continuar.',
        SOURCE_EVIDENCE_MISSING:
          'Anexe o documento original da operação antes de revisar o desconto.',
        NOT_A_SOURCE_DISCOUNT_CANDIDATE:
          'Este lançamento não contém desconto na conta incondicional mapeada.',
        SOURCE_JOURNAL_NOT_POSTED: 'O diário de origem não está contabilizado.',
        APPROVED_EVIDENCE_CHANGED:
          'A decisão já registrada não corresponde mais à evidência disponível. Preserve o histórico e contate o suporte para diagnóstico.',
        MAPPING_AMBIGUOUS:
          'Há mais de um mapeamento vigente para a conta de desconto incondicional.',
        SOURCE_IDENTITY_UNSUPPORTED: 'A origem não possui identidade contábil canônica suportada.',
        REVENUE_ALLOCATION_AMBIGUOUS:
          'O desconto não pode ser atribuído a uma única conta de receita.',
        DISCOUNT_SIGN_INVALID: 'A conta de desconto não possui saldo devedor válido.',
        DISCOUNT_EXCEEDS_REVENUE: 'O desconto excede a receita bruta da origem.',
        DIMENSION_ALLOCATION_AMBIGUOUS:
          'As dimensões do desconto não reconciliam com as dimensões da receita.',
      },
    },
    postDisabled: {
      unbalanced: 'Contabilizar fica desabilitado enquanto o lançamento estiver desbalanceado.',
      minLines: 'Contabilizar exige pelo menos duas linhas completas.',
      noPermission: 'Você não tem permissão para contabilizar.',
      noDraftPermission: 'Salvar alterações exige permissão para rascunhar.',
      incompleteLines: 'Há linhas incompletas ou inválidas.',
      currencyUnresolved: 'A moeda funcional da entidade não está disponível.',
    },
    reverseDisabled: {
      noPermission: 'Você não tem permissão para estornar.',
    },
    autoReverse: {
      label: 'Estorno automático no período seguinte',
      disabled: 'Requer permissão para criar estornos.',
      pendingBadge: 'Estorno pendente',
      pendingNotice:
        'Lançamento contabilizado, mas o estorno automático não foi possível agora; ficará pendente até o período abrir',
    },
    confirmPost: {
      title: 'Contabilizar lançamento',
      description:
        'O rascunho {{entryNumber}} será lançado no razão. Esta ação não pode ser desfeita sem um estorno.',
      confirm: 'Contabilizar',
    },
    postLifecycle: {
      loadingTitle: 'Contabilizando lançamento',
      loadingDescription: 'Salvando o rascunho e registrando as partidas no razão…',
      successTitle: 'Lançamento contabilizado',
      successDescription: 'O lançamento {{entryNumber}} foi registrado no razão com sucesso.',
      errorTitle: 'Não foi possível contabilizar',
      errorDescription: 'O lançamento não foi contabilizado. Tente novamente.',
      retry: 'Tentar novamente',
      close: 'Fechar',
      cancel: 'Cancelar',
      done: 'Concluir',
    },
    confirmReverse: {
      title: 'Estornar lançamento',
      description: 'O lançamento {{entryNumber}} será estornado no razão.',
      confirm: 'Estornar',
    },
    confirmCancelDraft: {
      title: 'Cancelar rascunho',
      description: 'O rascunho {{entryNumber}} será cancelado e não poderá ser contabilizado.',
      confirm: 'Cancelar rascunho',
    },
    confirmLeave: {
      title: 'Descartar alterações?',
      description: 'Há alterações não salvas. Se voltar agora, elas serão perdidas.',
      confirm: 'Sair sem salvar',
      stay: 'Continuar editando',
    },
    preview: {
      title: 'Pré-visualizar razão',
      description: 'Linhas como serão lançadas no razão.',
      account: 'Conta',
      debit: 'Débito',
      credit: 'Crédito',
      descriptionLabel: 'Histórico',
      costCenter: 'Centro de custo',
      department: 'Departamento',
      managerialAccount: 'Conta gerencial',
      empty: 'Inclua contas e valores para pré-visualizar o razão.',
      bookFallback: 'Livro do lançamento',
    },
    toast: {
      saved: 'Rascunho salvo.',
      posted: 'Lançamento contabilizado.',
      reversed: 'Lançamento estornado.',
      cancelled: 'Rascunho cancelado.',
    },
    notFound: 'Lançamento manual não encontrado.',
  },
} as const;

export const glEn = {
  common: {
    loading: 'loading...',
    select: 'Select',
    none: 'None',
    save: 'Save',
    cancel: 'Cancel',
    create: 'Create',
    saving: 'Saving...',
    now: 'Now',
    clear: 'Clear',
    moveUp: 'Move up',
    moveDown: 'Move down',
    close: 'Close',
    entityLabel: 'Entity',
    entityPlaceholder: 'Select entity',
    bookLabel: 'Book',
    bookPlaceholder: 'Select book',
    periodLabel: 'Period',
    periodPlaceholder: 'Select period',
    accountLabel: 'GL Account',
    accountPlaceholder: 'Select account',
    staleAccountOtherCoaVersion:
      'This account is not available for this field. Review the mapping or select another account.',
    glAccountSplit: {
      distributionLabel: 'Distribute across accounts:',
      addItemLabel: '+ Add account',
      itemLabel: 'account',
      itemsLabel: 'accounts',
    },
  },
  errors: {
    loadCoaVersions: 'Error loading chart of accounts versions.',
    publishVersion: 'Error publishing chart of accounts version.',
    loadAccounts: 'Error loading GL accounts.',
    loadBooks: 'Error loading GL books.',
    loadPeriods: 'Error loading periods.',
    periodNotFoundForEntity: 'Period not found for the selected entity.',
    loadRollupData: 'Error loading rollup/crosswalk data.',
    saveRollups: 'Error saving rollups. Make sure the version is in draft status.',
    saveRollupGroup: 'Error saving rollup group.',
    inactivateAccount: 'Error inactivating account. Make sure the version is in draft status.',
    createAccount: 'Error creating GL account.',
    updateAccount: 'Error updating GL account.',
    deleteMappedAccount:
      'This account is linked to an accounting configuration. Remap the system or record account before deleting it.',
  },
  scopedAccountSelector: {
    chart: 'Resolved chart of accounts:',
    empty: 'This chart of accounts has no available accounts.',
    scopeUnavailable: 'The chart of accounts scope could not be resolved.',
    selectEntityFirst: 'Select an entity first to choose a GL account.',
  },
  access: {
    loadError: 'Could not load the account permissions.',
    updateError: 'Could not update the access policy.',
    saveError: 'Could not save the changes.',
    protected: 'Data protected.',
    defaultRestored: 'Default access restored.',
    changesSaved: 'Changes saved.',
    manage: 'Manage access',
    protect: 'Protect account data',
    title: 'Access control',
    restrictionLabel: 'Restrict access',
    restrictionDescription:
      'Only authorized people and groups will be able to view this account and its balances.',
    inheritedDescription:
      'People with permission to view the chart of accounts can view this account.',
    restricted: 'Restricted access',
    useDefault: 'Use default access',
    addPeople: 'Add people',
    selectPeople: 'Select people',
    searchPeople: 'Search people',
    noPeople: 'No people available',
    addAnotherPerson: 'Add another person',
    addGroup: 'Add group',
    selectGroup: 'Select a group',
    peopleWithAccess: 'People with access',
    groupsWithAccess: 'Groups with access',
    group: 'Group',
    undo: 'Undo {{name}}',
    undoRemoval: 'Undo removal of {{name}}',
    remove: 'Remove {{name}}',
    confirm: 'Confirm',
    protectTitle: 'Protect this account data?',
    protectDescription:
      'Only authorized people and groups will be able to view this account and its balances.',
    defaultTitle: 'Use default access?',
    defaultDescription_one:
      'This account will again follow the normal chart-of-accounts permissions, and the current authorization will be removed. If you restrict this account later, the list starts empty.',
    defaultDescription_other:
      'This account will again follow the normal chart-of-accounts permissions, and the {{count}} current authorizations will be removed. If you restrict this account later, the list starts empty.',
    noRole: 'no role',
    viaGroups: 'Via group: {{groups}}',
    saveTitle: 'Save access changes?',
    saveDescription_one: '{{count}} access change will be applied.',
    saveDescription_other: '{{count}} access changes will be applied.',
    discardChangesTitle: 'Discard changes?',
    discardChangesDescription: 'Any access changes that have not been saved will be lost.',
    discardChangesConfirm: 'Discard changes',
  },
  pages: {
    coa: {
      title: 'Chart of accounts',
      description: 'View and version the GL chart of accounts with rollups and crosswalks.',
      selectEntity: 'Select entity',
      emptyState: {
        selectEntityTitle: 'Select an entity',
        selectEntityDescription:
          'Select an entity to view the chart of accounts. Tenants with more than one entity can have a different active version per entity.',
      },
      loadingVersions: 'Loading versions...',
      selectVersion: 'Select version',
      importTargetVersion: 'Target version',
      importTargetVersionHelp:
        'You can only import into a draft or applied version. Published/scheduled versions do not accept imports.',
      searchPlaceholder: 'Search accounts...',
      presets: {
        hideUnusedAccounts: 'Hide accounts without postings',
        hiddenUnusedNotice: 'Accounts without postings are hidden. To show them,',
        hiddenUnusedNoticeAction: 'click here',
        foldedChildren_one: '+ {{formattedCount}} account',
        foldedChildren_other: '+ {{formattedCount}} accounts',
        viewError: 'Could not load this view.',
        retry: 'Try again',
        viewDetailed: 'View detailed',
      },
      navigateToRollupDesigner: 'Rollup / Crosswalk',
      createAccount: 'Create account',
      createAccountSheet: {
        title: 'New account',
        description: 'Fill in the basic account details.',
        fields: {
          parentAccount: 'Parent account',
          parentAccountPlaceholder: 'Select parent account',
          code: 'Code',
          name: 'Name',
          namePlaceholder: 'New account',
          type: 'Type',
          naturalBalance: 'Natural balance',
          isPostable: 'Postable account',
          isContra: 'Contra account',
          isContraHelp:
            'Select when the balance reduces its primary account, such as accumulated depreciation or amortization.',
          contraOfAccount: 'Reduced primary account',
          contraOfAccountPlaceholder: 'Select the primary account',
          isConsolidationElimination: 'Consolidation elimination account',
          isConsolidationEliminationHelp:
            'Use only for an account dedicated to reciprocal head-office and branch balances.',
        },
        validation: {
          codeAlreadyExists: 'Code {{code}} already exists in this chart of accounts version.',
          parentRequired: 'Select the parent account before creating the account.',
          contraOfRequired: 'Select the primary account reduced by this contra account.',
        },
        actions: {
          create: 'Create',
        },
        accountTypes: {
          asset: 'Asset',
          liability: 'Liability',
          equity: 'Equity',
          revenue: 'Revenue',
          cogs: 'Cost (COGS)',
          expense: 'Expense',
          otherIncome: 'Other income',
          otherExpense: 'Other expense',
          contraAsset: 'Contra-asset',
          contraLiability: 'Contra-liability',
          contraEquity: 'Contra-equity',
        },
        naturalBalances: {
          debit: 'Debit',
          credit: 'Credit',
        },
      },
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      deleteDraft: 'Delete draft version',
      startDate: {
        action: 'Start date',
        title: 'Chart of accounts start date',
        label: 'Starts on',
        description_one:
          'The {{count}} account in this draft will start on this date. Documents with a competency date from this date on can use it.',
        description_other:
          'The {{count}} accounts in this draft will start on this date. Documents with a competency date from this date on can use them.',
        confirm: 'Save start date',
        hint: 'Starts: {{date}}',
        hintNone: 'No start date',
        errors: {
          COA_VERSION_NOT_DRAFT:
            'Only a draft chart of accounts version can change its start date.',
          COA_VERSION_START_DATE_INVALID: 'The chart of accounts start date is not a valid date.',
          generic: 'Error saving the start date.',
        },
      },
      deleteDraftConfirmTitle: 'Delete draft version?',
      deleteDraftConfirmDescription:
        'Version {{version}} will be permanently deleted. This action cannot be undone.',
      deleteAccountConfirm: 'Delete account',
      deleteAccountConfirmTitle: 'Delete account?',
      deleteAccountConfirmDescription:
        'Account {{account}} will be permanently deleted. This action cannot be undone.',
      publishVersion: 'Publish version',
      manageActivation: 'Activate / Schedule',
      activation: {
        title: 'Version activation',
        book: 'Book',
        selectBook: 'Select book',
        loadingPreview: 'Analyzing impact…',
        canActivate: 'Can activate',
        cannotActivate: 'Cannot activate',
        periodsToRestamp: 'Open periods to re-stamp',
        periodsKept: 'Periods with postings (kept)',
        periodsClosed: 'Closed periods',
        suggestedGoLive: 'Suggested go-live',
        blockingTitle: 'Blocking issues',
        warningsTitle: 'Warnings',
        goLiveDate: 'Go-live date (schedule)',
        goLiveDateCalendar:
          'The date is applied at midnight in the selected book’s accounting calendar.',
        activateNow: 'Activate now',
        schedule: 'Schedule',
        cancelSchedule: 'Cancel schedule',
        activateError: 'Error activating the chart of accounts version.',
        issues: {
          OPEN_PERIODS_WITH_POSTINGS:
            '{{count}} open period(s) have posted journals and will remain on the current version (history is immutable).',
          CROSSWALK_INCOMPLETE:
            '{{count}} account(s) in the active version are not mapped to the target version.',
          ALREADY_ACTIVE: 'This version is already active for this entity/book.',
          VERSION_NOT_PUBLISHED: 'The target version must be published before activation.',
          COA_ACTIVATION_IMPACT_STALE:
            'The impact analysis went stale during activation (the chart in force, the crosswalk, or the periods changed). Nothing was changed: refresh the activation preview and activate again.',
        },
      },
      deprecateVersion: 'Deprecate version',
      deprecateError: 'Error deprecating the chart of accounts version.',
      deprecation: {
        issues: {
          COA_VERSION_DEPRECATION_BLOCKED:
            'Cannot deprecate: still in use by {{count}} active or scheduled (entity, book) scope(s). Cancel the schedule or migrate the scope to another version before deprecating.',
        },
      },
      createVersion: 'New version',
      revenueClasses: 'Revenue classes',
      revenueClassesNoEntity: 'No Brazilian entity uses this chart version.',
      createVersionTitle: 'New chart of accounts version',
      createVersionDescription:
        'Create a draft version, optionally copying from an existing version.',
      crosswalkWithParent: 'Crosswalk with parent version:',
      mappings: '{{count}} mapping',
      mappings_plural: '{{count}} mappings',
      columns: {
        account: 'Account',
        code: 'Code',
        type: 'Type',
        naturalBalance: 'Natural balance',
        netBalance: 'Net balance',
        rollup: 'Rollup',
        isPostable: 'Postable',
        status: 'Status',
        effectiveRange: 'Effective range',
        actions: 'Actions',
      },
      boolean: {
        yes: 'Yes',
        no: 'No',
      },
      statusLabels: {
        active: 'Active',
        inactive: 'Inactive',
      },
      versionStatusLabels: {
        inUse: 'In use',
        draft: 'Draft',
        published: 'Published',
        scheduled: 'Scheduled',
        deprecated: 'Archived',
      },
      form: {
        versionNumberLabel: 'Version',
        versionNumberPlaceholder: 'E.g. 1.1, 2025-01',
        nameLabel: 'Name',
        namePlaceholder: 'Descriptive name for this version',
        descriptionLabel: 'Description (optional)',
        descriptionPlaceholder: 'Short summary of the version purpose',
        parentVersionLabel: 'Base version (optional)',
        parentVersionPlaceholder: 'Select a version to copy accounts from',
        parentVersionNone: 'None (start from scratch)',
        parentVersionHelp: 'If you pick a base version, accounts will be copied automatically.',
        notesLabel: 'Internal notes (optional)',
        notesPlaceholder: 'Context for history or audit',
        startDateLabel: 'Start date (optional)',
        startDateHelp:
          'The accounts of this version start on this date. Without one, they start on the day they are created or imported.',
      },
      createVersionSubmit: 'Create version',
      tooltips: {
        togglePostableOn: 'Enable postings',
        togglePostableOff: 'Disable postings',
      },
    },
    rollupDesigner: {
      saveRollups: 'Save rollups',
      saving: 'Saving...',
      groupsTitle: 'Rollup groups',
      accountMappingsTitle: 'Account → rollup mapping',
      balanceSheet: 'Balance sheet',
      incomeStatement: 'Income statement',
      subtotal: 'Subtotal',
      newGroupButton: 'New group',
      groupForm: {
        newTitle: 'New rollup group',
        originEventsTitle: 'Eventos de origem',
        originEventsEmpty: 'Nenhum evento de origem vinculado a este lançamento.',
        originEventsFallbackLabel: 'Evento de origem',
        originEventsButtonApBill: 'Ver conta a pagar',
        displayOrderLabel: 'Order',
        isSubtotalLabel: 'Subtotal',
        saveButton: 'Save',
        cancelButton: 'Cancel',
      },
    },
    rollups: {
      title: 'Rollups',
      back: 'Back',
      emptyState: {
        selectEntityTitle: 'Select an entity',
        selectEntityDescription: 'Select an entity to see the GL accounts available for rollups.',
      },
      listTitle: 'FP&A Rollups',
      newRollup: 'New rollup',
      standardBadge: 'Standard',
      create: 'Create',
      accounts: 'accounts',
      noRollupSelected: 'No rollup selected',
      noRollupSelectedDesc: 'Select a rollup from the list on the left or create a new one.',
      noRollups: 'No rollups created yet.',
      noRollupsHint: 'Click + to create a new one.',
      rename: 'Rename',
      restoreDefault: 'Restore default',
      restoreDefaultConfirm:
        'Restore "{{name}}" to its shipped definition? Custom accounts, filters and formula will be replaced.',
      restoredToDefault: 'Rollup restored to its default definition.',
      deleteRollup: 'Delete rollup',
      deleteRollupConfirm: 'Delete "{{name}}"? This archives the rollup.',
      addAccount: 'Add account',
      removeAccount: 'Remove account',
      groupNameLabel: 'Name',
      groupNamePlaceholder: 'E.g. Gross revenue, Net income...',
      groupTypeLabel: 'Type',
      groupTypeSum: 'Σ Sum',
      groupTypeFormula: 'ƒ Calculated',
      includedAccountsLabel: 'Included accounts',
      accountTypesLabel: 'Account-type selection',
      advancedLabel: 'Advanced',
      formatLabel: 'Format',
      parentLabel: 'Parent rollup',
      readOnlyViaApi: 'Read-only in this editor — edit via MCP/API.',
      formulaLabel: 'Formula',
      moreAccounts: '+{{count}} more',
      formulaReadOnly:
        'This formula uses metrics or prior-period references and is read-only here — edit via MCP/API.',
      addToFormula: 'Add to formula',
      parentheses: 'Parentheses',
      rollupRefs: 'Rollups',
      numberToken: 'Number',
      removeToken: 'Remove formula token',
      filtersWhere: 'Filters (WHERE)',
      logicAnd: 'Logic: AND',
      addFilter: 'Add filter',
      removeFilter: 'Remove filter',
      filterDialogTitle: 'Add filter',
      filterDimensionLabel: 'Dimension',
      filterDimensionPlaceholder: 'Select a dimension',
      filterOperatorLabel: 'Operator',
      filterValuesLabel: 'Value(s)',
      add: 'Add',
      dimensions: {
        entity: 'Entity',
        managerialAccount: 'Managerial account',
        costCenter: 'Cost center',
        department: 'Department',
        vendor: 'Vendor',
      },
      errors: {
        nameTaken: 'A rollup with this name already exists.',
        inUse: 'This rollup is referenced by templates or formulas and cannot be deleted.',
        segmentFilterContabil: 'Segment filters are only supported on Gerencial-source rollups.',
        segmentTextFilterUnsupported:
          'Rollup filters only accept predefined values; free-text values cannot be filtered yet.',
        segmentFilterValueConflict:
          'Use predefined values or free text in the segment filter, not both together.',
        segmentTextValueNotAllowed:
          'This field does not accept free text. Choose a predefined catalog value.',
        segmentPredefinedValueNotAllowed:
          'This field has no value catalog. Remove predefined values from this filter.',
        segmentTextValueTooLong: 'Free text in the filter must be at most 200 characters.',
        accountSourceMismatch: "The selected account does not match the rollup's fonte.",
        accountNotFound: 'Account not found.',
        accountDuplicate: 'Duplicate account on the rollup.',
        accountRefShape: 'Invalid account reference.',
        formulaRequired: 'Calculated rollups require a formula.',
        formulaInvalid: 'Invalid formula.',
        formulaCycle: 'The formula creates a circular reference between rollups.',
        calculatedNoSelection: 'Calculated rollups cannot have account selections or filters.',
        aggregationNoFormula: 'Sum rollups cannot have a formula.',
        rollupRefNotFound: 'The formula references a rollup that does not exist.',
        parentCycle: 'The rollup hierarchy cannot contain cycles.',
        definitionReported:
          'This rollup feeds an already-reported snapshot — the change requires restatement consent via API.',
        notStandard: 'Only standard rollups can be restored.',
        standardDefinitionMissing: 'No standard definition found for this rollup.',
      },
    },
    fxEvidence: {
      title: 'Exchange-rate evidence',
      contextLabel: 'Context',
      pairLabel: 'Currency pair',
      rateLabel: 'Exact rate',
      requestedDateLabel: 'Requested accounting date',
      quoteDateLabel: 'Actual quote date',
      sourceLabel: 'Source',
      providerLabel: 'Provider',
      quoteIdentifierLabel: 'Quote identifier',
      manualActorLabel: 'Manual-rate actor',
      manualTimeLabel: 'Override date/time',
      manualReasonLabel: 'Override reason',
      context: {
        PROVISION: 'Provision',
        REVALUATION: 'Revaluation',
        SETTLEMENT: 'Settlement',
      },
      source: {
        IDENTITY: 'Identity',
        PTAX: 'PTAX',
        MANUAL: 'Manual',
      },
    },
    journalDetails: {
      title: 'Journal details',
      description: 'Journal header, lines, and accounting evidence.',
      loading: 'Loading journal...',
      error: 'Could not load the journal.',
      retry: 'Try again',
      dateLabel: 'Date',
      statusLabel: 'Status',
      documentTypeLabel: 'Document type',
      memoLabel: 'Memo',
      linesTitle: 'Journal lines',
      accountLabel: 'Account',
      debitLabel: 'Debit',
      creditLabel: 'Credit',
      emptyLines: 'No journal lines found.',
    },
    originLink: {
      title: 'Origin links',
      description:
        'Assert that a subledger record and a historically-imported journal are the same economic event.',
      ledgerSafetyNotice:
        'This screen writes the link row only. No journal is posted, reversed or edited here.',
      tabs: {
        queue: 'Record queue',
        queueDescription: 'Record → journal: subledger records that still carry no linked journal.',
        journals: 'Imported journals',
        journalsDescription:
          'Journal → record: historical journals and the links they already carry.',
      },
      filters: {
        targetKindAll: 'All record kinds',
        coverageStateAll: 'Any coverage',
        linkStateAll: 'Linked and unlinked',
        linkStateLinked: 'Linked only',
        linkStateUnlinked: 'Unlinked only',
        lifecycleRoleAll: 'All lifecycle stages',
        searchPlaceholder: 'Search by number, memo or party',
        memoSearchPlaceholder: 'Filter historical memo text',
        bookPlaceholder: 'Select the book',
        periodPlaceholder: 'All periods',
        datePlaceholder: 'Date range',
      },
      prompts: {
        selectEntityTitle: 'Select an entity',
        selectEntityDescription:
          'Pick the entity whose history was imported to see the record queue and the imported journals.',
        selectBook: 'Select a book to list the imported journals.',
        loading: 'Loading...',
        error: 'Failed to load origin-link data.',
        emptyQueue: 'No records awaiting a link for the selected filters.',
        emptyJournals: 'No imported journals found for the selected filters.',
      },
      summary: {
        totalUnlinked: 'Unlinked records',
        totalJournals: 'Imported journals',
        linkedJournals: 'Linked',
        unlinkedJournals: 'Unlinked',
      },
      targetKinds: {
        AP_BILL_ACCRUAL: 'Payable accrual',
        AP_PAYMENT_CLEARING: 'Payment clearing',
        AR_INVOICE_ACCRUAL: 'Invoice accrual',
        CASH_MOVEMENT: 'Cash movement',
      },
      targetKindHints: {
        AP_BILL_ACCRUAL:
          'The payable was recognized in the subledger (accrual), but has no accrual journal linked yet.',
        AP_PAYMENT_CLEARING: 'A payable payment with no clearing (settlement) journal linked yet.',
        AR_INVOICE_ACCRUAL:
          'The invoice was recognized in the subledger (accrual), but has no accrual journal linked yet.',
        CASH_MOVEMENT: 'A bank or card transaction with no settlement link yet.',
      },
      openOriginal: 'Open original record in a new tab',
      importNotes: {
        ACCRUAL_UNRESOLVED: {
          label: 'No journal determined',
          description:
            'The importer could not determine a single accrual journal for this record (ambiguous candidates, or none found). Resolve it by linking manually here.',
        },
        ACCRUAL_LINK_UNDETERMINABLE: {
          label: 'Link undeterminable',
          description:
            'The importer found a candidate journal, but withheld the link because the same journal was also claimed by another case (or would need more than one journal, which the system cannot represent). A human needs to decide who the journal belongs to.',
        },
        ACCRUAL_OUTSIDE_WINDOW: {
          label: 'Outside the import window',
          description:
            "The record date falls outside the import's declared range, so no automatic linking was ever attempted.",
        },
        AMBIGUOUS: {
          label: 'Multiple candidates',
          description:
            'More than one imported journal matched this record and the importer did not pick between them. Review the candidates and link manually.',
        },
        UNMATCHED: {
          label: 'No candidate found',
          description: 'No imported journal matched this record.',
        },
        DIVERGENT: {
          label: 'Disagrees with the manifest',
          description:
            'The deterministic matcher and the approved manifest name different journals for this case. The conflict blocks the import and needs manual resolution.',
        },
        AP_VENDOR_UNRESOLVED: {
          label: 'Vendor not identified',
          description:
            'No vendor exists for the document on file; the bill was created without a linked vendor.',
        },
        AR_INVOICE_LINK_CONTESTED: {
          label: 'Journal contested by another invoice',
          description:
            'The journal that would match this invoice is also claimed by a competing invoice. No link was created automatically.',
        },
        CUSTOMER_DOCUMENT_UNRESOLVED: {
          label: 'Customer document not identified',
          description: 'The customer document on the invoice was not identified.',
        },
        CUSTOMER_UNIDENTIFIABLE: {
          label: 'Customer not identifiable',
          description: 'The invoice customer could not be identified from the available data.',
        },
        CUSTOMER_CREATION_NOT_AUTHORIZED: {
          label: 'Customer creation not authorized',
          description:
            'The customer does not exist on file and this stage is not authorized to create it automatically.',
        },
      },
      coverage: {
        candidatesAvailableBadge: 'Candidates available',
        inCoverageNoMatchBadge: 'No match',
        outOfCoverageBadge: 'Out of coverage',
        inCoverageNoMatchTitle: 'No suggested candidates',
        inCoverageNoMatchDescription:
          'Imported journals exist for this range, but none matched the record. Search manually for the right journal.',
        outOfCoverageTitle: 'Outside the import coverage',
        outOfCoverageDescription:
          'The record’s date falls outside the imported range, so there is no journal to link to. This cannot be resolved here: it needs a wider historical import run.',
        boundsLabel: 'Imported coverage',
        boundsRange: '{{from}} to {{to}}',
        boundsUnknown: 'No imported journals for this entity and book.',
        recordDateLabel: 'Record date',
      },
      manualSearch: {
        label: 'Manual search',
        placeholder: 'Document number, memo or amount',
        action: 'Search',
        clear: 'Clear search',
        resultsTitle: 'Manual search results',
      },
      queue: {
        table: {
          record: 'Record',
          kind: 'Kind',
          party: 'Party',
          date: 'Date',
          amount: 'Amount',
          coverage: 'Coverage',
          candidates: 'Candidates',
          importNote: 'Import note',
          actions: 'Actions',
        },
        actions: {
          link: 'Link',
          view: 'View candidates',
          audit: 'Audit trail',
          crossToJournals: 'Show in journals',
        },
      },
      journals: {
        table: {
          date: 'Date',
          journalNumber: 'Journal',
          memo: 'Memo',
          related: 'Related (suggested)',
          amount: 'Amount',
          period: 'Period',
          links: 'Links',
          candidates: 'Candidates',
          actions: 'Actions',
        },
        noLinks: 'No link',
        orderByLabel: 'Order by',
        orderOptions: {
          DATE_DESC: 'Date: newest',
          DATE_ASC: 'Date: oldest',
          AMOUNT_DESC: 'Amount: highest',
          AMOUNT_ASC: 'Amount: lowest',
          HISTORICAL_ASC: 'Memo: A–Z',
          HISTORICAL_DESC: 'Memo: Z–A',
        },
        noRelated: 'No suggestion',
        lifecycleRoles: {
          ACCRUAL: 'Accrual',
          CLEARING: 'Clearing',
        },
        relatedDocument: 'Document {{documents}}',
        sameAmount: 'Same amount',
        differentAmount: 'Different amount',
        linksCount: '{{count}} link(s)',
        fromImport: 'From import',
        fromConsole: 'From console',
        linkedAt: 'Linked on {{date}}',
        compoundHint:
          'A compound source journal can settle several titles — several links here is the correct behaviour.',
        actions: {
          viewJournal: 'View journal {{journalId}} lines',
          link: 'Link a record',
          unlink: 'Remove link',
          audit: 'Audit trail',
          crossToQueue: 'Show in queue',
        },
        journalDetailSubtitle: 'Journal {{journalId}}',
      },
      drawer: {
        titleRecordToJournal: 'Link a record to an imported journal',
        titleJournalToRecord: 'Link an imported journal to a record',
        recordSection: 'Record',
        journalSection: 'Journal',
        candidatesTitle: 'Suggested candidates',
        openRecord: 'View record',
        journalDate: 'Journal date',
        recordDescription: 'Description',
        recordDateKinds: {
          COMPETENCY: 'Competency date',
          ISSUE: 'Issue date',
          PAID: 'Payment date',
          SCHEDULED: 'Scheduled date',
          POSTED: 'Bank posting date',
        },
        candidateScopes: {
          accountsPayable: 'Accounts payable',
          bankTransactions: 'Bank transactions',
        },
        candidateRank: 'Suggestion #{{rank}}',
        candidateScore: 'Score {{score}}',
        signalsTitle: 'Signals',
        signalMatched: 'matches',
        signalUnmatched: 'differs',
        select: 'Select',
        selected: 'Selected',
        changeSelection: 'Change selection',
        readOnlyNotice:
          'You have read-only access to origin links. You can review candidates but not assert links.',
        allocationLabel: 'Allocated amount',
        allocationHelp:
          'Partial allocation is legitimate; allocations against a transaction may not exceed its amount.',
        reasonLabel: 'Reason',
        reasonHelp: 'State why this one and not another. The reason is kept in the audit trail.',
        reasonPlaceholder: 'Describe the evidence that supports this link',
        reasonRequired: 'A reason is required to continue.',
        preflightRunning: 'Checking...',
        preflightError: 'Failed to check the link.',
        confirm: 'Confirm link',
        confirming: 'Linking...',
        cancel: 'Cancel',
        submitError: 'Failed to record the link.',
        loadError: 'Failed to load candidates.',
      },
      pagination: {
        summary: 'Page {{page}} of {{pages}} — {{total}} record(s)',
      },
      warnings: {
        title: 'Discrepancies (they do not block the link)',
        acknowledgeHint: 'Acknowledge the flagged discrepancies to continue.',
        informationalHint: 'The others are informational and need no acknowledgement.',
        acknowledge: 'I acknowledge',
        journalValue: 'Journal',
        recordValue: 'Record',
        codes: {
          ORIGIN_LINK_AMOUNT_MISMATCH: 'Amounts differ',
          ORIGIN_LINK_DATE_MISMATCH: 'Dates differ',
          ORIGIN_LINK_PERIOD_CLOSED: 'Closed period — does not block the link',
          ORIGIN_LINK_PARTY_MISMATCH: 'Parties differ',
          ORIGIN_LINK_PARTIAL_ALLOCATION: 'Partial allocation',
        },
      },
      errors: {
        title: 'Blockers',
        codes: {
          ORIGIN_LINK_JOURNAL_NOT_FOUND: 'Journal not found',
          ORIGIN_LINK_JOURNAL_NOT_HISTORICAL:
            'The journal did not come from a historical import and is not eligible',
          ORIGIN_LINK_JOURNAL_NOT_POSTED: 'The journal is not posted',
          ORIGIN_LINK_JOURNAL_SLOT_TAKEN: 'This journal’s slot is already taken',
          ORIGIN_LINK_RECORD_NOT_FOUND: 'Record not found',
          ORIGIN_LINK_RECORD_ALREADY_LINKED: 'The record is already linked',
          ORIGIN_LINK_ENTITY_MISMATCH: 'Different entities',
          ORIGIN_LINK_BOOK_MISMATCH: 'Different books',
          ORIGIN_LINK_ALLOCATION_EXCEEDS_TRANSACTION:
            'The allocation exceeds the cash transaction amount',
          ORIGIN_LINK_JOURNAL_HAS_NO_SETTLEMENT:
            'Link the payment to this journal first — the cash movement settles the payment, not the journal',
          ORIGIN_LINK_SETTLEMENT_AMBIGUOUS:
            'This journal settles more than one title; the request must name which one the cash movement settles',
          ORIGIN_LINK_REASON_REQUIRED: 'A reason is required',
          ORIGIN_LINK_WARNING_NOT_ACKNOWLEDGED: 'There are unacknowledged discrepancies',
          ORIGIN_LINK_POSTING_NOT_FOUND: 'Link row not found',
        },
        slotHolder: {
          title: 'This journal is already linked to:',
          description:
            'An intended outcome, not a defect: another record holds this journal’s slot. Open it to decide which one keeps the link.',
          open: 'Open record',
        },
      },
      unlink: {
        title: 'Remove origin link',
        description:
          'The link row will be deleted permanently; only the audit event survives. No journal is posted, reversed or edited.',
        reasonLabel: 'Reason',
        reasonPlaceholder: 'Describe why this link should be removed',
        reasonRequired: 'A reason is required to remove the link.',
        confirm: 'Remove link',
        confirming: 'Removing...',
        cancel: 'Cancel',
        error: 'Failed to remove the link.',
      },
      events: {
        title: 'Audit trail',
        description: 'What the operator was looking at when they decided.',
        empty: 'No events recorded.',
        loading: 'Loading events...',
        error: 'Failed to load the audit trail.',
        table: {
          date: 'Date',
          action: 'Action',
          actor: 'Actor',
          record: 'Record',
          journal: 'Journal',
          reason: 'Reason',
          evidence: 'Evidence seen',
        },
        actions: {
          LINK: 'Link',
          UNLINK: 'Unlink',
        },
        suggestionSources: {
          RANKED_SUGGESTION: 'Ranked suggestion (#{{rank}})',
          MANUAL_SEARCH: 'Manual search',
        },
        acknowledgedWarnings: 'Acknowledged discrepancies',
        journalSnapshot: 'Journal at decision time',
        recordSnapshot: 'Record at decision time',
        allocatedAmount: 'Allocated amount',
        close: 'Close',
      },
    },
    ledger: {
      title: 'General ledger',
      description: 'View journal entries by account, book and period.',
      emptyState: 'No entries found for the selected filters.',
      filters: {
        movementLabel: 'Movement',
        movementPlaceholder: 'Filter accounts',
        withMovement: 'Only accounts with movement',
        withoutMovement: 'Only accounts without movement',
        all: 'All accounts',
        accountLabel: 'Account (optional)',
        accountPlaceholder: 'Filter by account',
        accountsSelected: '{{count}} accounts selected',
        periodTag: 'Period {{period}}',
        dateFromLabel: 'From date',
        dateToLabel: 'To date',
        dateFromPlaceholder: 'yyyy-mm-dd',
        dateToPlaceholder: 'yyyy-mm-dd',
        amountMinLabel: 'Min amount',
        amountMaxLabel: 'Max amount',
        amountMinPlaceholder: '0.00',
        amountMaxPlaceholder: '0.00',
        orderByLabel: 'Order by',
        orderByAccount: 'Account',
        orderByDate: 'Date',
        orderByDebit: 'Debit',
        orderByCredit: 'Credit',
        orderByBalance: 'Balance',
        bookPlaceholder: 'Select book',
        periodPlaceholder: 'Select period',
      },
      prompts: {
        selectEntity: 'Select an entity to view the ledger.',
        selectEntityTitle: 'Select an entity',
        selectEntityDescription:
          'Select an entity to view the ledger. Choose an entity to view its journal entries by account, book, and period.',
        selectBookAndPeriod: 'Select book and period (account is optional) to load the ledger.',
        loading: 'Loading ledger...',
        noAccounts: 'No accounts found for the selected filters.',
        error: 'Error loading ledger',
        accessRestricted: 'Restricted access',
        loadButton: 'Load ledger',
      },
      table: {
        index: '#',
        date: 'Date',
        account: 'Account',
        documentType: 'Doc. type',
        documentNumber: 'Number',
        copyDocumentNumber: 'Copy full number {{number}}',
        documentNumberCopied: 'Full number copied.',
        documentNumberCopyError: 'Could not copy the full number.',
        memo: 'Memo',
        debit: 'Debit',
        credit: 'Credit',
        balance: 'Balance',
        transactionAmount: 'Transaction amount',
        summary: {
          book: 'Book:',
          period: 'Period:',
          opening: 'Opening balance:',
          debit: 'Debits:',
          credit: 'Credits:',
          closing: 'Closing balance:',
          entries: 'Entries:',
        },
      },
      view: {
        byAccount: 'By account',
        chronological: 'Timeline',
      },
      panel: {
        title: 'Account ledger',
        movementBadge: 'Movement',
        periodLabel: 'Period: {{period}}',
        entriesCount: '{{count}} entry',
        entriesCount_plural: '{{count}} entries',
        empty: 'No entries found for this account.',
        aiSummaryTitle: 'AI summary',
        aiSummaryPatternsLabel: 'Patterns',
        aiSummaryPatternsHighlight: 'Most movements',
        aiSummaryPatternsText: 'are concentrated in a few recurring business events.',
        aiSummaryAnomaliesLabel: 'Anomalies',
        aiSummaryAnomaliesText:
          'No significant deviations detected compared to the previous period.',
        aiSummaryCompositionLabel: 'Composition',
        aiSummaryCompositionText: 'A small set of counterparties explains most of the balance.',
        aiSummaryError: 'Could not generate the AI summary.',
        searchPlaceholder: 'Search in entries...',
        amountFilterAll: 'All amounts',
        amountFilterGt1k: '> R$ 1.000',
        amountFilterGt5k: '> R$ 5.000',
      },
      presets: {
        title: 'Ledger views',
        description: 'Configure how this chart is read without changing any journal entries.',
        detailed: 'Detailed',
        manage: 'Views',
        saveCurrent: 'Save current view',
        name: 'Name',
        groupSameDay: 'Group same-day postings',
        foldedRoots: 'Group child accounts',
        foldedRootsHelper:
          'Shows the parent account in a single line instead of one line per vendor, customer, or employee. Totals do not change.',
        slotSearchPlaceholder: 'Search by account code or name',
        unmappedSlotHelper: 'No account mapped in this chart version',
        hideReversedPairs: 'Hide reversed pairs',
        hideReversedPairsTooltip:
          'Hides a posting and its reversal only when both fall in the period being read. If the reversal is in another period, the original posting stays visible, with the "reversed on" badge.',
        makeDefault: 'Make default',
        defaultBadge: 'Default',
        delete: 'Delete',
        deleteTitle: 'Delete view?',
        deleteDescription:
          'Shared links using this view will stop working. Journal entries will not change.',
        saved: 'View saved.',
        deletedLinkError: 'This ledger view was deleted. Choose another view or Detailed.',
        wrongChartError: 'This view belongs to another chart of accounts.',
        invalidRowModeError: 'Invalid row mode. Use Grouped or Lines.',
      },
      rowMode: {
        label: 'Ledger rows',
        grouped: 'Postings',
        lines: 'Lines',
      },
      grouped: {
        source: 'Source',
        unknownSource: 'Unknown source',
        documentCount: '{{count}} document',
        documentCount_plural: '{{count}} documents',
        documentCount_other: '{{count}} documents',
        reversedOn: 'reversed on {{date}}',
        loadingMembers: 'Loading journals...',
        membersError: 'Could not load the journals in this grouped posting.',
        postingSources: {
          arInvoice: 'Customer invoice',
          arInvoiceAccrual: 'Customer invoice accrual',
          arInvoiceReversal: 'Customer invoice reversal',
          arNfseIssReclassification: 'NFS-e ISS reclassification',
          arRevenueRecognition: 'Revenue recognition',
          arAggregateReclassification: 'Aggregate billing reclassification',
          arAggregateWithholding: 'Withholdings on the aggregate billing invoice',
          arContractChildReclassification: 'Reclassification between contract accounts',
          arTaxCollected: 'Tax collected',
          arSettlementReconciliation: 'Settlement reconciliation',
          arRailSettlement: 'Receivables rail settlement',
          arSettlementPayableAdjustment: 'Settlement payable adjustment',
          arInternalTransfer: 'Internal transfer',
          arDebitNote: 'Debit note',
          manualEntry: 'Manual entry',
          reversal: 'Journal reversal',
          payableProvision: 'Payable provision',
          payablePayment: 'Payable payment',
          apFxRevaluation: 'Payable FX revaluation',
          apRemediation: 'Payable remediation',
          apBillDeferral: 'Payable deferral',
          apBillDeferralCancellation: 'Payable deferral cancellation',
          apBillDeferralReclassification: 'Payable deferral reclassification',
          apBillDeferralRefund: 'Payable deferral refund',
          apClientRecoverableWriteOff: 'Client recoverable write-off',
          receivableReceipt: 'Receivable receipt',
          statutoryPaymentClearing: 'Statutory payment clearing',
          statutoryAutoProvision: 'Automatic statutory provision',
          statutoryAutoProvisionReclassification: 'Statutory provision reclassification',
          statutoryBypassReclassification: 'Statutory bypass reclassification',
          taxLiabilityRailMigration: 'Tax liability rail migration',
          glOnboardingImport: 'General ledger onboarding import',
          historicalLedgerImport: 'Historical ledger import',
          revenueClassificationBackfill: 'Revenue classification backfill',
          apPaymentSettlement: 'Payable payment settlement',
          creditCardSettlement: 'Credit card settlement',
          offsetRootRemediation: 'Offset root remediation',
          assetOpeningBalance: 'Asset opening balance (demo load)',
          expenseAccrual: 'Expense accrual',
          fxRemeasurement: 'FX remeasurement',
          payroll: 'Payroll',
          statutoryAccountingFallback: 'Unclassified tax provision',
          fixedAssetCapitalization: 'Fixed asset capitalization',
          fixedAssetDepreciation: 'Fixed asset depreciation',
          fixedAssetDisposal: 'Fixed asset disposal',
          fixedAssetTransfer: 'Construction-in-progress transfer',
          fixedAssetPisCofinsRecoverabilityAllowance:
            'PIS/COFINS recoverability allowance on fixed assets',
          leaseRecognition: 'Lease recognition',
          leaseLiabilityReclassification: 'Lease liability reclassification',
          leaseRemeasurement: 'Lease remeasurement',
          intangibleAllocationCorrection: 'Intangible allocation correction',
          intangibleProjectGoLive: 'Intangible project go-live',
          intangibleProjectWriteOff: 'Intangible project write-off',
          revenueTaxProvision: 'PIS/COFINS provision on revenue',
          revenueTaxProvisionReversal: 'PIS/COFINS provision reversal',
          revenueTaxCashRelease: 'PIS/COFINS release on receipt',
          revenueTaxCashReleaseReversal: 'PIS/COFINS release reversal',
          costProvision: 'Cost of revenue provision',
          costProvisionReversal: 'Cost of revenue provision reversal',
          costProvisionClose: 'Cost of revenue provision close-out',
          costMatchReclassification: 'Cost provision relief by a bill',
          costMatchUndo: 'Cost provision relief undone',
          creditCardProviderReclassification: 'Credit card account reclassification',
          managerialChartSwap: 'Managerial chart swap',
          taxAssessment: 'Tax assessment',
        },
      },
    },
    trialBalance: {
      title: 'Trial balance',
      description: 'Summary of balances by GL account.',
      emptyState: 'No balances found for the selected filters.',
      prompts: {
        selectEntity: 'Select an entity to view the trial balance.',
        selectEntityTitle: 'Select an entity',
        selectEntityDescription:
          'Select an entity to view the trial balance. Choose an entity to view its balances by GL account, book, and period.',
        selectBookAndPeriod: 'Select book and period to load the trial balance.',
        loading: 'Loading trial balance...',
        error: 'Error loading trial balance',
      },
      filters: {
        bookPlaceholder: 'Select book',
        periodPlaceholder: 'Select period',
        accountPlaceholder: 'Filter by account',
        amountMinPlaceholder: '0.00',
        amountMaxPlaceholder: '0.00',
        amountRangeLabel: 'Amount range',
        noMatches: 'No accounts match the account or amount filters.',
      },
      syntheticBadge: 'Synthetic',
      movementsRestricted: 'Restricted',
      movementsRestrictedHint:
        'Opening and closing balances are available, but this account’s movements are confidential.',
      folding: {
        detailed: 'Detailed',
        marker_one: '{{count}} folded account',
        marker_other: '{{count}} folded accounts',
        expand: 'Show folded accounts',
        loadingChildren: 'Loading folded accounts',
        editInLedger: 'Edit views in the ledger',
      },
      periodLabel: 'Period',
      showPeriod: 'Show',
      hidePeriod: 'Hide',
      table: {
        account: 'Account',
        code: 'Code',
        rollup: 'Rollup',
        opening: 'Opening balance',
        debits: 'Debits',
        credits: 'Credits',
        closing: 'Closing balance',
        netBalance: 'Net balance',
      },
      actions: {
        export: 'Export',
        print: 'Print',
        shareLink: 'Share link',
        exportEmpty: 'No data to export.',
        exportSuccess: 'Excel export started.',
        exportError: 'Failed to export trial balance.',
        shareLinkCopied: 'Link copied to clipboard.',
        shareLinkError: 'Could not copy link.',
        shareLinkLoading: 'Loading shared trial balance...',
        exportPdfSuccess: 'PDF export started.',
        exportPdfError: 'Failed to export trial balance to PDF.',
      },
    },
    balanceSheet: {
      title: 'Balance sheet',
      description: 'Aggregated balances by rollup groups (assets, liabilities and equity).',
      emptyState: 'No balances found for the selected filters.',
      prompts: {
        selectEntity: 'Select an entity to view the balance sheet.',
        selectBookAndPeriod: 'Select book and period to load the balance sheet.',
        loading: 'Loading balance sheet...',
        error: 'Error loading balance sheet',
      },
    },
    incomeStatement: {
      prompts: {
        selectEntity: 'Select an entity to view the income statement.',
        selectBookAndPeriod: 'Select book and period to load the income statement.',
      },
    },
    periodPlanning: {
      title: 'Period planning',
      description:
        'View and plan accounting periods by entity and book, based on the configured calendar.',
      loading: 'Loading period planning...',
      loadButton: 'Load planning',
      emptyState: 'No periods found for the selected entity and book.',
      error: 'Error loading period planning.',
      prompts: {
        selectEntity: 'Select an entity to view period planning.',
        selectBook: 'Select a book to view period planning.',
      },
      summary: {
        entity: 'Entity:',
        book: 'Book:',
        calendar: 'Calendar:',
        calendarUnknown: 'Calendar not defined',
        periodicity: 'Periodicity:',
        fiscalYearStartMonth: 'Fiscal year start month:',
      },
    },
    calendars: {
      title: 'Accounting calendars',
      loading: 'Loading calendars...',
      newButton: 'New calendar',
      editButton: 'Edit',
      table: {
        name: 'Name',
        timeZone: 'Time zone',
        fiscalYearStartMonth: 'Fiscal year start month',
        periodicity: 'Periodicity',
        status: 'Status',
        actions: 'Actions',
      },
      form: {
        createTitle: 'New accounting calendar',
        editTitle: 'Edit accounting calendar',
        fields: {
          name: 'Name',
          namePlaceholder: 'e.g. Fiscal calendar',
          timeZone: 'Time zone',
          timeZonePlaceholder: 'e.g. America/Sao_Paulo',
          fiscalYearStartMonth: 'Fiscal year start month (1–12)',
          periodicity: 'Periodicity',
          periodicityMonthly: 'Monthly (12 months)',
          periodicityQuarterly: 'Quarterly (4 quarters)',
          periodicityWeekly: 'Weekly (52–53 weeks)',
          periodicityThirteenPeriods: '13 periods (4 weeks each)',
          periodicity445: '4-4-5 (retail)',
          periodicity454: '4-5-4',
          periodicity544: '5-4-4',
          status: 'Status',
          statusActive: 'Active',
          statusInactive: 'Inactive',
        },
      },
    },
    periods: {
      title: 'Accounting periods',
      description:
        'View, create and manage accounting periods by entity and book. Close, reopen or lock periods as part of your close process.',
      loading: 'Loading periods...',
      newButton: 'New period',
      editButton: 'Edit',
      filters: {
        bookPlaceholder: 'Select book',
      },
      table: {
        period: 'Period',
        entity: 'Entity',
        book: 'Book',
        startDate: 'Start',
        endDate: 'End',
        status: 'Status',
        actions: 'Actions',
      },
      prompts: {
        selectEntity: 'Select an entity to view periods.',
        selectBook: 'Select a book to view periods.',
      },
      statusLabels: {
        open: 'Open',
        closed: 'Closed',
        locked: 'Locked',
      },
      actions: {
        createPeriod: 'Create period',
        generateYear: 'Generate periods for year',
        genericError: 'Could not update period.',
        aiPostingBlocked:
          'Some bills in this period have an AI entry that is not reviewed yet or still pending; review the "Accounting postings to review" card on the closing checklist.',
        close: 'Close period',
        reopen: 'Reopen period',
        lock: 'Lock period',
        reopenConfirm:
          'Reopening this period will also reopen all closed periods up to the current period for this book/entity. Do you want to continue?',
      },
      generateYear: {
        title: 'Generate fiscal year periods',
        description:
          'Creates all periods for the year for the selected entity and book (e.g. Jan–Dec). Existing periods are skipped. New periods are open for retroactive posting.',
        yearLabel: 'Fiscal year',
        yearPlaceholder: 'e.g. 2024',
        submit: 'Generate',
        success: 'Created: {{created}}. Skipped (already exist): {{skipped}}.',
        error: 'Could not generate periods.',
      },
    },
    books: {
      title: 'GL books',
      description: 'Manage your organization GL books.',
      emptyState: 'No books found.',
      loading: 'Loading books...',
      footerCount_one: '{{count}} book',
      footerCount_other: '{{count}} books',
      newButton: 'New book',
      editButton: 'Edit',
      searchPlaceholder: 'Search by code or name...',
      filters: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        entityAll: 'All entities',
        status: 'Status',
      },
      actions: {
        create: 'New book',
        edit: 'Edit',
      },
      form: {
        createTitle: 'New GL book',
        editTitle: 'Edit GL book',
        createDescription: 'Create a GL book and link it to an entity.',
        editDescription: 'Edit GL book details.',
        lockedAfterPosting: 'This book has posted journals and can no longer be edited.',
        fields: {
          code: 'Code',
          codePlaceholder: 'e.g. MAIN',
          name: 'Name',
          namePlaceholder: 'e.g. Statutory book',
          type: 'Type',
          typePlaceholder: 'Select type',
          typeStatutory: 'Statutory',
          typeTax: 'Tax',
          typeManagement: 'Management',
          typeConsolidation: 'Consolidation',
          typeSandbox: 'Sandbox',
          scope: 'Scope',
          scopePlaceholder: 'Select scope',
          scopeEntity: 'Entity',
          scopeTenant: 'Group',
          reportingCurrency: 'Reporting currency',
          reportingCurrencyPlaceholder: 'Select currency',
          functionalCurrency: 'Functional currency',
          functionalCurrencyPlaceholder: 'Select currency',
          framework: 'Accounting framework',
          frameworkPlaceholder: 'Select accounting framework',
          status: 'Status',
          statusPlaceholder: 'Select status',
          statusActive: 'Active',
          statusInactive: 'Inactive',
          entity: 'Entity',
          entityPlaceholder: 'Select entity',
          entityOptional: 'No link',
          calendar: 'Calendar',
          calendarPlaceholder: 'Select calendar',
          calendarOptional: 'No link',
          chart: 'Chart of accounts',
          chartPlaceholder: 'Select a chart of accounts',
          chartNotNeededForMemo: 'Tax-basis (TAX_BASIS) books do not use a chart of accounts.',
          noPublishedCharts:
            'No published chart of accounts is available. Publish a chart of accounts before linking the book to an entity.',
        },
      },
      table: {
        code: 'Code',
        name: 'Name',
        type: 'Type',
        scope: 'Scope',
        reportingCurrency: 'Reporting currency',
        status: 'Status',
        actions: 'Actions',
      },
      values: {
        type: {
          statutory: 'Statutory',
          tax: 'Tax',
          management: 'Management',
          consolidation: 'Consolidation',
          sandbox: 'Sandbox',
        },
        scope: {
          entity: 'Entity',
          group: 'Group',
        },
        status: {
          active: 'Active',
          inactive: 'Inactive',
        },
      },
    },
    multicurrency: {
      title: 'Multicurrency operations',
      description: 'Immutable quotes, per-book remeasurement, and close exceptions.',
      refresh: 'Refresh',
      manualQuote: 'Manual quote',
      manualDescription: 'The quote is created pending and requires independent approval.',
      enabledCurrencies: 'Enabled currencies',
      activeQuotes: 'Active quotes',
      openExceptions: 'Open exceptions',
      quotes: 'Quotes and versions',
      exceptions: 'Remeasurement exceptions',
      pair: 'Pair',
      purpose: 'Purpose',
      date: 'Requested date',
      rate: 'Rate',
      source: 'Source',
      status: 'Status',
      approve: 'Approve',
      period: 'Period',
      reason: 'Reason',
      remediation: 'Remediation',
      from: 'Base currency',
      to: 'Quote currency',
      evidence: 'Evidence URL',
      actualRateAt: 'Observed rate date and time',
      actualRateAtHelp:
        'The exact moment the rate was observed by the source — distinct from the accounting requested date below.',
      retry: 'Try again',
      loading: 'Loading…',
      statuses: {
        ACTIVE: 'Active',
        PENDING_APPROVAL: 'Pending approval',
        SUPERSEDED: 'Superseded',
        REJECTED: 'Rejected',
        PREVIEWED: 'Previewed',
        RUNNING: 'Running',
        COMPLETED: 'Completed',
        COMPLETED_WITH_EXCEPTIONS: 'Completed with exceptions',
        FAILED: 'Failed',
      },
      noExceptions: 'No open exceptions.',
      loadError: 'Could not load multicurrency operations.',
      manualCreated: 'Quote submitted for approval.',
      manualCreateError: 'Could not create the manual quote.',
      quoteApproved: 'Quote approved.',
      quoteApproveError: 'Could not approve the quote.',
      runs: 'Remeasurement runs',
      functionalCurrency: 'Functional currency',
      noRuns: 'No remeasurement runs.',
      runCreatedAt: 'Created at',
      execute: 'Execute',
      runExecuted: 'Remeasurement executed.',
      runExecuteError: 'Could not execute the remeasurement.',
      errors: {
        pairSame: 'Base and quote currency must be different.',
        rateInvalid: 'Enter a positive exact rate.',
        reasonRequired: 'A reason is required.',
        evidenceRequired: 'The evidence URL is required.',
        dateRequired: 'The requested date is required.',
        actualRateAtRequired: 'The observed rate date and time is required.',
      },
    },
  },
  periods: {
    form: {
      createTitle: 'New period',
      createDescription: 'Create a period from the entity/book calendar.',
      editTitle: 'Edit period',
      editDescription: 'Edit period details.',
      fields: {
        periodId: 'Period ID',
        periodIdPlaceholder: 'e.g. 2024-01',
        startDate: 'Start date',
        endDate: 'End date',
        entityId: 'Entity',
        entityIdPlaceholder: 'Select entity',
        bookId: 'Book',
        bookIdPlaceholder: 'Select book',
        fiscalYear: 'Fiscal year',
        fiscalYearPlaceholder: 'e.g. 2024',
        periodOption: 'Period',
        periodOptionPlaceholder: 'Select period',
      },
      createFromCalendar: {
        loadingPeriods: 'Loading periods...',
        noPeriods: 'No periods defined for this year. Check entity, book and year.',
      },
    },
  },
  selectors: {
    accounts: {
      noneAvailable: 'No accounts available',
    },
    books: {
      noneAvailable: 'No books available',
    },
    periods: {
      noneAvailable: 'No periods available',
      currentPeriod: 'View current period',
    },
  },
  actions: {
    glAccount: {
      actionLabel: 'Set GL Account',
      selectLabel: 'GL Account',
      withSplitPrefix: 'with split of',
    },
  },
  consolidatedRollup: {
    errors: {
      CONSOLIDATED_ROLLUP_SCOPES_REQUIRED: 'Select at least one entity to consolidate.',
      CONSOLIDATED_ROLLUP_DUPLICATE_SCOPE:
        'The same entity was included twice — remove the duplicate so its balances are not counted twice.',
      CONSOLIDATED_ROLLUP_INVALID_ACCOUNTING_DATE:
        'The cutoff date given is not a real calendar date (for example 30 February). Enter a real date — the report never rolls a cutoff into the next month.',
      CONSOLIDATED_ROLLUP_PERIOD_NOT_FOUND:
        'One of the entities has no period covering the date given. Generate that entity’s period or pick another date.',
      CONSOLIDATED_ROLLUP_REPORTING_CURRENCY_UNSUPPORTED:
        'The chosen reporting currency is not enabled for accounting. Pick another currency or enable it in the currency master.',
      CONSOLIDATED_ROLLUP_INSUFFICIENT_VISIBILITY:
        'Your access does not cover every account in this consolidation, and a partial consolidated total gives no sign that it is incomplete. Request access to the restricted accounts (or to payroll) to run this report.',
      CONSOLIDATED_ROLLUP_ORPHANED_BALANCE:
        'Some balance rows point at GL accounts that no longer exist. They cannot be assigned to any rollup group, and a total that omitted them would read as complete. Repair those records before consolidating.',
      CONSOLIDATED_ROLLUP_ACCOUNT_UNMAPPED:
        'An in-scope account has no consolidation rollup group in its CoA version. Map the account named in the message before consolidating — the report never drops balances.',
      CONSOLIDATED_ROLLUP_EQUITY_TRANSLATION_UNSUPPORTED:
        'An equity account is held in a functional currency other than the reporting currency. Translating it requires historical-rate equity layers and a cumulative translation adjustment line, which this report cannot derive. Consolidate that entity in its own functional currency, or exclude equity accounts from the rollup groups in scope.',
      CONSOLIDATED_ROLLUP_INTRAGROUP_BALANCE_PRESENT:
        'One of the selected entities carries an open intercompany position. Intragroup balances and results must be eliminated before a combined total can be reported as consolidated, and this report cannot eliminate them. Settle the position or drop that entity from the scope.',
      CONSOLIDATED_ROLLUP_CATEGORY_MISMATCH:
        'A balance-sheet rollup group maps an income-statement account (or the reverse). Fix the mapping: it would be translated at the wrong exchange rate.',
      CONSOLIDATED_ROLLUP_RATE_UNAVAILABLE:
        'No exchange rate for the currency pair and date named in the message. Record the rate (closing for balance sheet, average for income statement) — balances in different currencies are never summed untranslated.',
    },
  },
  manualEntries: {
    title: 'Manual entries',
    subtitle: 'Drafts, posted entries, and reversals in the ledger.',
    newEntry: 'New entry',
    editorTitleNew: 'New manual entry',
    editorTitle: 'Manual entry',
    breadcrumbList: 'Manual entries',
    filters: {
      entity: 'Entity',
      period: 'Period',
      periodPlaceholder: 'Select date range',
      numberPlaceholder: 'E.g. LM-2026-0001',
      descriptionPlaceholder: 'Search by memo',
      createdByPlaceholder: 'Select user',
      documentTypeAll: 'All types',
      status: 'Status',
      statusAll: 'All',
      minimum: 'Minimum',
      maximum: 'Maximum',
      debitMinimum: 'Minimum debit',
      debitMaximum: 'Maximum debit',
      creditMinimum: 'Minimum credit',
      creditMaximum: 'Maximum credit',
      applied: 'Active filters',
      clearAll: 'Clear filters',
      remove: 'Remove filter {{filter}}',
      filterNumber: 'Filter number',
      filterEntity: 'Filter entity',
      filterPeriod: 'Filter period',
      filterDocumentType: 'Filter type',
      filterStatus: 'Filter status',
      filterCreatedBy: 'Filter creator',
      filterDescription: 'Filter memo',
      filterDebit: 'Filter debit',
      filterCredit: 'Filter credit',
    },
    status: {
      DRAFT: 'Draft',
      POSTED: 'Posted',
      REVERSED: 'Reversed',
      CANCELLED: 'Cancelled',
    },
    documentTypes: {
      MANUAL: 'Manual',
      ADJUSTMENT: 'Adjustment',
    },
    columns: {
      number: 'Number',
      date: 'Date',
      entity: 'Entity',
      documentType: 'Type',
      status: 'Status',
      createdBy: 'Created by',
      description: 'Memo',
      debit: 'Debit',
      credit: 'Credit',
    },
    sort: {
      tooltip: 'Click to sort by this column',
      sortBy: 'Sort by {{column}}{{direction}}',
      sortAsc: 'ascending',
      sortDesc: 'descending',
    },
    empty: 'No manual entries found.',
    emptyFiltered: 'No manual entries match the filters.',
    emptyFilteredDescription: 'Clear the filters to see all manual entries.',
    loading: 'Loading manual entries…',
    loadError: 'Could not load manual entries.',
    pagination: {
      page: 'Page {{page}} of {{totalPages}}',
      summary_one: 'Page {{page}} of {{totalPages}} • {{count}} result',
      summary_other: 'Page {{page}} of {{totalPages}} • {{count}} results',
    },
    header: {
      entity: 'Entity',
      date: 'Date',
      documentType: 'Document type',
      book: 'Book',
      bookPlaceholder: 'Fixed by entity',
      currency: 'Functional currency',
      currencyPlaceholder: 'Fixed by entity',
      description: 'Memo',
      descriptionPlaceholder: 'E.g. Vacation accrual, August 2026',
      draftBadge: 'Draft · {{entryNumber}}',
    },
    details: {
      title: 'Entry details',
      subtitle: 'Enter the entity, date, and general entry information.',
    },
    lines: {
      title: 'Lines',
      add: 'Add line',
      remove: 'Remove line',
      account: 'Account',
      debit: 'Debit',
      credit: 'Credit',
      description: 'Line memo',
      dimensions: 'Dimensions',
      showDimensions: 'Show dimensions for line {{line}}',
      hideDimensions: 'Hide dimensions for line {{line}}',
      costCenter: 'Cost center',
      costCenterPlaceholder: 'Select a cost center',
      department: 'Department',
      departmentPlaceholder: 'Select a department',
      managerialAccount: 'Managerial account',
      managerialAccountPlaceholder: 'Select a managerial account',
      incomplete: 'Incomplete line: enter an account and a debit or credit amount.',
      invalidAmount: 'Invalid amount. Use up to two decimal places and a positive value.',
    },
    totals: {
      title: 'Totals',
      debit: 'Debit total',
      credit: 'Credit total',
      debits: 'Debits',
      credits: 'Credits',
      difference: 'Difference',
      differenceValue: 'Difference of {{amount}}',
      balanced: 'Balanced',
      unbalanced: 'Unbalanced',
      empty: 'No values',
      progressLabel: 'Debit and credit balancing progress',
      incomplete: 'There are incomplete or invalid lines.',
    },
    validation: {
      title: 'Validations',
      entity: 'Entity selected',
      date: 'Date entered',
      lines: 'At least two complete lines',
      balanced: 'Debits and credits balanced',
    },
    attachments: {
      title: 'Attachments',
      empty: 'No attachments.',
      uploadedAt: 'Uploaded {{date}}',
      saveFirst: 'Save the draft to attach files.',
      dropPrompt: 'Attach calculation memo, spreadsheet, or email',
      dropHint: 'or drag it here',
      tooLarge: 'The attachment exceeds the 5 MB limit.',
      upload: 'Attach file',
      uploading: 'Uploading…',
      delete: 'Delete attachment',
      toastUploaded: 'Attachment uploaded.',
      toastDeleted: 'Attachment deleted.',
      confirmDelete: {
        title: 'Delete attachment',
        description: 'The file "{{fileName}}" will be removed from the entry.',
        confirm: 'Delete attachment',
      },
    },
    actions: {
      save: 'Save draft',
      saving: 'Saving…',
      preview: 'Preview ledger',
      post: 'Post',
      posting: 'Posting…',
      reverse: 'Reverse',
      reversing: 'Reversing…',
      cancel: 'Back',
      openLedger: 'Open ledger',
      reviewSourceDiscount: 'Review source tax discount',
      reviewSourceDiscountNeedsAttachment:
        'Attach the original document while the entry is still a draft.',
      cancelDraft: 'Cancel draft',
      cancelling: 'Cancelling…',
    },
    sourceDiscount: {
      title: 'Review source unconditional discount',
      description:
        'Bind the deduction only to the original document that states the discount before any future event.',
      gross: 'Gross revenue',
      discount: 'Documented discount',
      net: 'Net basis',
      evidence: 'Source document',
      evidencePlaceholder: 'Select an attachment',
      code: 'Evidence code',
      evidenceDescription: 'Evidence description',
      statedOnSourceDocument:
        'I confirm the discount is stated on the operation original document.',
      independentOfFutureEvent:
        'I confirm the discount does not depend on payment, receipt, or another future event.',
      confirm: 'Confirm eligibility',
      saving: 'Confirming…',
      cancel: 'Cancel',
      done: 'Done',
      retry: 'Try again',
      loading: 'Checking the journal and documents…',
      alreadyApproved: 'This source already has an immutable documentary decision.',
      successTitle: 'Eligibility recorded',
      success: 'Discount eligibility recorded. Process the pending PIS/COFINS provisions.',
      errorTitle: 'Eligibility could not be recorded',
      errors: {
        evidence: 'Select the source document.',
        changed:
          'The journal or document changed. Reopen the review and confirm the current facts.',
      },
      refusals: {
        SOURCE_NOT_FOUND: 'The source was not found.',
        MANUAL_ENTRY_NOT_POSTED: 'Post the journal before reviewing the discount.',
        SOURCE_JOURNAL_SCOPE_AMBIGUOUS:
          'The source has more than one eligible accounting journal. Review the scope before continuing.',
        SOURCE_EVIDENCE_MISSING:
          'Attach the operation original document before reviewing the discount.',
        NOT_A_SOURCE_DISCOUNT_CANDIDATE:
          'This journal has no discount in the mapped unconditional-discount account.',
        SOURCE_JOURNAL_NOT_POSTED: 'The source journal is not posted.',
        APPROVED_EVIDENCE_CHANGED:
          'The recorded decision no longer matches the available evidence. Preserve the history and contact support for diagnosis.',
        MAPPING_AMBIGUOUS: 'More than one unconditional-discount mapping is effective.',
        SOURCE_IDENTITY_UNSUPPORTED: 'The source has no supported canonical accounting identity.',
        REVENUE_ALLOCATION_AMBIGUOUS: 'The discount cannot be attributed to one revenue account.',
        DISCOUNT_SIGN_INVALID: 'The discount account has no valid debit balance.',
        DISCOUNT_EXCEEDS_REVENUE: 'The discount exceeds the source gross revenue.',
        DIMENSION_ALLOCATION_AMBIGUOUS:
          'The discount dimensions do not reconcile with the revenue dimensions.',
      },
    },
    postDisabled: {
      unbalanced: 'Post stays disabled while the entry is unbalanced.',
      minLines: 'Posting requires at least two complete lines.',
      noPermission: 'You do not have permission to post.',
      noDraftPermission: 'Saving changes requires draft permission.',
      incompleteLines: 'There are incomplete or invalid lines.',
      currencyUnresolved: 'The entity functional currency is not available.',
    },
    reverseDisabled: {
      noPermission: 'You do not have permission to reverse.',
    },
    autoReverse: {
      label: 'Automatic reversal in the following period',
      disabled: 'Requires permission to create reversals.',
      pendingBadge: 'Reversal pending',
      pendingNotice:
        'Entry posted, but automatic reversal could not run now; it will stay pending until the period opens.',
    },
    confirmPost: {
      title: 'Post entry',
      description:
        'Draft {{entryNumber}} will be posted to the ledger. This cannot be undone without a reversal.',
      confirm: 'Post',
    },
    postLifecycle: {
      loadingTitle: 'Posting entry',
      loadingDescription: 'Saving the draft and recording its lines in the ledger…',
      successTitle: 'Entry posted',
      successDescription: 'Entry {{entryNumber}} was posted to the ledger successfully.',
      errorTitle: 'Could not post entry',
      errorDescription: 'The entry was not posted. Try again.',
      retry: 'Try again',
      close: 'Close',
      cancel: 'Cancel',
      done: 'Done',
    },
    confirmReverse: {
      title: 'Reverse entry',
      description: 'Entry {{entryNumber}} will be reversed in the ledger.',
      confirm: 'Reverse',
    },
    confirmCancelDraft: {
      title: 'Cancel draft',
      description: 'Draft {{entryNumber}} will be cancelled and cannot be posted.',
      confirm: 'Cancel draft',
    },
    confirmLeave: {
      title: 'Discard changes?',
      description: 'You have unsaved changes. If you leave now, they will be lost.',
      confirm: 'Leave without saving',
      stay: 'Keep editing',
    },
    preview: {
      title: 'Preview ledger',
      description: 'Lines as they will land in the ledger.',
      account: 'Account',
      debit: 'Debit',
      credit: 'Credit',
      descriptionLabel: 'Memo',
      costCenter: 'Cost center',
      department: 'Department',
      managerialAccount: 'Managerial account',
      empty: 'Add accounts and amounts to preview the ledger.',
      bookFallback: 'Entry book',
    },
    toast: {
      saved: 'Draft saved.',
      posted: 'Entry posted.',
      reversed: 'Entry reversed.',
      cancelled: 'Draft cancelled.',
    },
    notFound: 'Manual entry not found.',
  },
} as const;
